export const contentEnglish = {
  code: "EN",
  labels: {
    // App Digital Admin
    digitalAdmin: "Digital Admin",
    digitalAdminApp: "App Digital Admin",
    digitalAdminSarl: "Digital Admin SARL",
    copilotTitle: "Digital Copilot",
    copilotComingSoon: "Your AI assistant is coming soon",
    copilotOpen: "Open Copilot",
    copilotClose: "Close Copilot",
    copilotPlaceholder: "Ask your AI assistant a question",
    copilotInputPlaceholder: "Type your message...",
    copilotSend: "Send",
    copilotConnected: "Connected",
    copilotConnecting: "Connecting...",
    copilotDisconnected: "Disconnected",
    copilotConnectionLost: "Connection lost",
    copilotReconnect: "Reconnect",
    copilotToolRunning: "Searching",
    copilotActionProposed: "Action proposed",
    copilotConfirm: "Confirm",
    copilotReject: "Reject",
    copilotConfirming: "Confirming...",
    copilotRejecting: "Rejecting...",
    copilotActionBlockInput: "Confirm or reject the proposed action to continue",
    copilotActionHint: "Confirm, reject, or type a correction",
    copilotActionCreateContact: "New contact",
    copilotActionCreateInvoice: "New invoice",
    copilotActionCreateQuote: "New quote",
    copilotActionCreateOrder: "New order",
    copilotActionCreateProviderInvoice: "New provider invoice",
    copilotActionCreateProviderOrder: "New provider order",
    copilotActionCreateExpense: "New expense",
    copilotActionCreateAccountingEntry: "New accounting entry",
    copilotResultContactCreated: "Contact created",
    copilotResultInvoiceCreated: "Invoice created",
    copilotResultQuoteCreated: "Quote created",
    copilotResultOrderCreated: "Order created",
    copilotResultProviderInvoiceCreated: "Provider invoice created",
    copilotResultProviderOrderCreated: "Provider order created",
    copilotResultExpenseCreated: "Expense created",
    copilotResultAccountingEntryCreated: "Accounting entry created",
    copilotResultGeneric: "Action completed",
    copilotResultFailed: "The action failed",
    copilotDiscussDocument: "Discuss with Copilot",
    copilotDocumentAttached: "Attached document",
    copilotDetachDocument: "Detach",
    copilotViewPiece: "View document",
    copilotAttachDocument: "Attach a document",
    copilotSearchExisting: "Search existing",
    copilotUploadNew: "Upload new",
    copilotSearchPlaceholder: "Search by name...",
    copilotUploading: "Uploading...",
    copilotUploadError: "Upload failed",
    copilotNoDocuments: "No documents found",
    uploadingFile: "Uploading file...",
    uploadProgress: "Upload progress",
    zipExtractionStarted: "ZIP extraction started",
    zipExtractionInProgress: "Your ZIP file is being extracted in the background. Documents will appear shortly.",
    uploadFailed: "Upload failed",
    uploadTooLarge: "The file exceeds the maximum allowed size",
    copilotOnline: "Online",
    copilotYou: "You",
    copilotHistory: "History",
    copilotNewConversation: "New conversation",
    copilotNoThreads: "No conversations",
    copilotActionRejected: "Action rejected",
    copilotActionFailedPast: "Action failed",
    copilotLoadingMessages: "Loading messages...",
    copilotSuggestCreateExpense: "Create an expense",
    copilotSuggestCreateProviderInvoice: "Create a provider invoice",
    copilotSuggestMsgCreateExpense: "Create an expense from the attached document.",
    copilotSuggestMsgCreateProviderInvoice: "Create a provider invoice from the attached document.",
    copilotActionStartBatch: "Batch processing",
    copilotBatchConfirmText: "Process all pending documents automatically. The copilot will analyze and create the corresponding entries.",
    copilotBatchMilestone: "Batch processing",
    copilotSuggestProcessDocuments: "Process my documents",
    copilotSuggestMsgProcessDocuments: "Process all my pending documents automatically.",
    viewDocument: "View document",
    digitalAdminPro: "Digital Admin Pro",
    welcomeToDigitalAdmin: "Welcome to Digital Admin",
    purchasePro: "Buy Digital Admin Pro",
    signIn: "Sign in to Digital Admin",

    // Words sentences
    about: "About",
    successful: "Successful",
    error: "Error",
    accountSettings: "Account settings",
    actions: "Actions",
    additional: "Additional",
    address: "Address",
    administrativeArea: "Canton",
    amount: "Amount",
    sum: "Sum",
    amountTotal: "Total amount",
    apply: "Apply",
    approved: "Approved",
    ascending: "Ascending",
    addContact: "Add contact",
    addContent: "Add content",
    addSignature: "Add signature",
    avatar: "Avatar",
    back: "Back",
    bban: "BBAN",
    bicSwift: "BIC/SWIFT",
    bimester: "Bimester",
    calculatedValuesAreReferential: "Calculated values are referential",
    cancel: "Cancel",
    canceled: "Canceled",
    city: "City",
    comment: "Comment",
    completed: "Completed",
    companyContact: "Company contact",
    content: "Content",
    registerNumber: "Register number",
    concerning: "Concerning",
    contactInformation: "Contact information",
    continue: "Continue",
    country: "Country",
    create: "Create",
    createdDate: "Creation date",
    currency: "Currency",
    customer: "Customer",
    date: "Date",
    day: "Day",
    days: "Days",
    default: "Default",
    delete: "Delete",
    descending: "Descending",
    description: "Description",
    detail: "Detail",
    details: "Details",
    discard: "Discard",
    doNotGroup: "Do not group",
    edit: "Edit",
    email: "Email",
    end: "End",
    endDate: "End date",
    excel: "Excel",
    export: "Export",
    filter: "Filter",
    filterOptions: "Filter options",
    firstName: "First name",
    group: "Group",
    halfYear: "Half year",
    iban: "IBAN",
    identity: "Identity",
    inProgress: "In progress",
    justNow: "Just now",
    lastDay: "Last day",
    lastName: "Last name",
    legalInformation: "Legal information",
    list: "List",
    location: "Location",
    menu: "Menu",
    message: "Message",
    messages: "Messages",
    archived: "Archived",
    read: "Read",
    unread: "Not read",
    archive: "Archive",
    noNumber: "No number",
    noMatchingRecordsFound: "No matching records found",
    month: "Month",
    months: "Months",
    number: "Number",
    sortAlphabetically: "Sort alphabetically",
    pages: "Pages",
    pdf: "PDF",
    pending: "Pending",
    person: "Person",
    phone: "Phone",
    phoneNumber: "Phone number",
    priceGross: "Gross price",
    priceNet: "Net price",
    priceTotal: "Total price",
    product: "Product",
    products: "Products",
    qrIban: "QR-IBAN",
    quantity: "Quantity",
    stockLimitReached: "Stock limit reached",
    lowStockWarning: "Low stock warning",
    accepted: "Accepted",
    declined: "Declined",
    rejected: "Rejected",
    sent: "Sent",
    remove: "Remove",
    removeReference: "Remove reference",
    removeContent: "Remove content",
    removeSignature: "Remove signature",
    removeRequirement: "Remove block",
    removeVoucher: "Remove voucher",
    requirement: "Block",
    requirements: "Blocks",
    reset: "Reset",
    saveChanges: "Save changes",
    searchResults: "Search results",
    selectExportFormat: "Select export format",
    send: "Send",
    service: "Service",
    services: "Services",
    appService: "Application service",
    appServices: "Application services",
    signature: "Signature",
    signatures: "Signatures",
    start: "Start",
    startDate: "Start date",
    status: "Status",
    street: "Street",
    subTotal: "Subtotal",
    support: "Support",
    symbol: "Symbol",
    tax: "Tax",
    taxSale: "Sale tax",
    taxPurchase: "Purchase tax",
    taxRate: "Tax rate",
    taxTotal: "Total tax",
    trimester: "Trimester",
    total: "Total",
    totalAmount: "Total amount",
    top: "Top",
    type: "Type",
    timeInterval: "Time interval",
    interval: "Interval",
    unitMeasure: "Unit of measure",
    unitPrice: "Unit price",
    update: "Update",
    validity: "Validity",
    value: "Value",
    vatNumber: "VAT/IDE number",
    contactCode: "Contact code",
    webSite: "Site internet",
    week: "Week",
    weeks: "Weeks",
    view: "View",
    yes: "Yes",
    zipCode: "Zip code",
    gross: "Gross",
    net: "Net",
    rebate: "Rebate",
    rebateTotal: "Total rebate",
    selectOptionAddAmountPercentageDesired: "Select an option and add the desired amount or percentage",
    changeImage: "Change image",
    changeLogo: "Change logo",
    exportError: "Export error",
    failedToLoadTheScript: "Failed to load the script",
    identificationNumberForACompany: "Identification number of a company for european operations",
    internationalBankAccountNumberIban: "International bank account number (IBAN)",
    listOfCompaniesIHaveAccess: "List companies I have access to",
    noRecordsFound: "No records found",
    noResultsFound: "No results found",
    companyNotSubjectToVat: "No VAT statements",
    companyNotSubjectToVatDescription: "This company is not subject to VAT. No VAT statement periods are available.",
    removeImage: "Remove image",
    selectTheTypeOfContact: "Select the type of contact you want to create",
    specifyTheUniqueUUID: "Specify the unique UUID of a user or company",
    theDefaultBankAccountIsTheCompanys: "The default treasury account is the company's",
    theDefaultCurrencyIsTheCompanys: "The default currency is the company's",
    theDefaultShapeOrVersionOfAQrInvoiceToDownloadIsTheClients: "The default shape or version of a QR invoice to download is the client's",
    theDefaultLanguageToDownloadIsTheClients: "The default language to download is the client's",
    youMustAcceptTheTermsAndConditions: "You must accept the terms and conditions",
    acceptingInvitationToAccessCompany: "Accepting invitation to access the company",
    verificationYourAccount: "Verification of your account",
    addCompany: "Add company",
    allInLicense: "All-in license",
    buyNow: "Buy now",
    comingSoon: "Coming soon",
    licenseTerms: "License terms",
    pageNotFound: "Page not found",
    viewInvitations: "View invitations",
    purchase: "Purchase",
    reload: "Reload",
    systemError: "System error",
    dashboard: "Dashboard",
    abbreviation: "Abbreviation",
    amountPurchases: "Purchase amount",
    amountSales: "Sales amount",
    best: "Best",
    companyInsight: "Company insight",
    comparativeInterval: "Comparative interval",
    comparisonIncomeAndExpenses: "Comparison of income & expenses",
    customerPayments: "Customer payments",
    customRange: "Custom range",
    debtPercent: "Debt (%)",
    distributionOfQuotes: "Distribution of quotes by status",
    distributionOfOrders: "Distribution of orders by status",
    expirationDate: "Expiration date",
    creationDate: "Creation date",
    invoicesStillToBePaid: "Invoices still to be paid",
    invoicesStillToBePaidByTheCustomer: "Invoices still to be paid by the customer",
    invoicesWithMoreDebt: "Invoices with more debt",
    ordersByState: "Orders by state",
    ordersToBilled: "Orders to be billed",
    paidPercent: "Paid (%)",
    percentage: "Percentage",
    quotesByState: "Quotes by state",
    quotesAccepted: "Accepted quotes",
    quotesApproved: "Approved quotes",
    quotesToExpire: "Quotes to expire",
    retailAnalysisSample: "Retail analysis sample",
    representationOfSalesAndPurchases: "Representation of sales and purchases per month over a year",
    salesVsPurchases: "Sales vs Purchases",
    thisBimester: "This bimester",
    thisTrimester: "This trimester",
    thisHalfYear: "This half year",
    thisMonth: "This month",
    thisWeek: "This week",
    thisYear: "This year",
    today: "Today",
    turnout: "Invoice amount",
    viewAll: "View all",
    worst: "Worst",
    yesterday: "Yesterday",
    fixedAmount: "Fixed amount",
    discount: "Discount",
    account: "Account",
    changeEmail: "Change email",
    changePassword: "Change password",
    confirmNewPassword: "Confirm new password",
    currentPassword: "Current password",
    emailAddress: "Email address",
    enterNewEmailAddress: "Enter a new email address",
    fullName: "Full name",
    newPassword: "New password",
    pleaseCheckYourEmailInbox: "Please check your email inbox",
    profileCompleation: "Profile completion",
    profileDetails: "Profile details",
    signInMethod: "Sign-in method",
    updateEmail: "Update email",
    updatePassword: "Update password",
    updateUser: "Update user",
    validateAccount: "Validate account",
    viewUser: "View user",
    user: "User",
    users: "Users",
    confirmPassword: "Confirm password",
    createAnAccount: "Create an account",
    enterYourEmailToResetYourPassword: "Enter your email to reset your password",
    goToLoginPage: "Go to login page",
    goToPreviousPage: "Go to previous page",
    language: "Language",
    languages: "Languages",
    myProfile: "My profile",
    notVerified: "Not verified",
    password: "Password",
    resetPassword: "Reset password",
    signInHere: "Sign in here",
    signOut: "Sign out",
    submit: "Submit",
    userProfile: "User profile",
    use8OrMoreCharacters: "Use 8 or more characters with a combination of uppercase and lowercase letters, numbers, and symbols",
    verified: "Verified",
    welcome: "Welcome",
    company: "Company",
    companies: "Companies",
    current: "Current",
    addDeadlinePaymentParameter: "Add payment deadline parameter",
    addFeatureParameter: "Add feature parameter",
    addImage: "Add image",
    addTax: "Add tax",
    addDeadline: "Add deadline",
    addFeature: "Add feature",
    addTaxRateParameter: "Add tax rate parameter",
    addUnit: "Add unit",
    addUnitMeasureParameter: "Add unit measure parameter",
    advanceSettings: "Advanced settings",
    aNewCompanyWillBeCreated: "A new company will be created based on the entered data",
    browseUsers: "Browse users",
    companyAddress: "Company address",
    companyAdvanceSettings: "Company advanced settings",
    companyDownloadSettings: "Company download settings",
    companyAccountingSettings: "Company accounting setup",
    companyGeneralSettings: "Configuring general company parameters",
    companyInformationSettingGeneral: "Setting up general company information",
    companyIdentity: "Company identity",
    companyLogo: "Company logo",
    companyName: "Company name",
    legalForm: "Legal form",
    legalFormSarl: "LLC (Sàrl)",
    legalFormSa: "SA (Corp.)",
    legalFormRi: "Sole proprietorship",
    legalFormSnc: "General partnership (SNC)",
    legalFormCooperative: "Cooperative",
    legalFormAssociation: "Association",
    legalFormFondation: "Foundation",
    legalFormAutre: "Other",
    createCompany: "Create company",
    createAndSave: "Create & Save",
    newCompany: "New company",
    designOfDocumentToDownloadQuotesAndInvoices: "Design of document for downloading quotes, orders, and invoices",
    downloadSettings: "Download settings",
    dueDates: "Due dates for invoice payment",
    editCompany: "Edit company",
    free: "Free",
    generalSettings: "General settings",
    helpPage: "Help page",
    image: "Image",
    inviteAccessCompany: "Invite to access the company",
    legal: "Legal",
    listUsers: "List users",
    logo: "Logo",
    name: "Name",
    new: "New",
    noResultFound: "No result found",
    overview: "Overview",
    accountingSettings: "Accounting settings",
    pleaseTryAgainWithADifferentQuery: "Please try again with a different query",
    predefinedTaxesFees: "Predefined taxes fees",
    predefinedValues: "Predefined values",
    freeInput: "Free input",
    inputMethod: "Input method",
    private: "Private",
    removeLogo: "Remove logo",
    selectModel: "Select model",
    selectAndSaveDesiredLayoutToDownload: "Select and save the desired layout to download the quote, order, and invoice",
    selectAndSaveOneToFourDesiredColors: "Select and save one to four desired colors for the quote, order, and invoice design",
    sendInvitation: "Send invitation",
    settings: "Settings",
    taxValue: "Tax value",
    templateColors: "Template colors",
    templateModel: "Template model",
    unitsOfMeasure: "Units of measurement for a service or product",
    characteristicsForServiceProduct: "Characteristics for a service or product",
    uuidCode: "UUID code",
    uuidCompany: "UUID company",
    uuidOrName: "UUID/Name",
    usersWhoAreSubscribed: "Users who are subscribed and have access to the company",
    viewCompany: "View company",
    viewMoreUsers: "View more users",
    treasury: "Treasury",
    treasuryAccount: "Treasury account",
    treasuryCashAccount: "Treasury Cash Account",
    treasuryCardAccount: "Treasury Card Account",
    noCashTreasuryAccounts: "No cash treasury accounts available",
    noCardTreasuryAccounts: "No card treasury accounts available",
    conceptAccount: "Concept account",
    treasuryAccounts: "Treasury accounts",
    codeOfBelongingToABankingOrganization: "Code of belonging to a banking organization",
    createNewTreasuryAccount: "Create new treasury account",
    createTreasuryAccount: "Create treasury account",
    listTreasuryAccounts: "List treasury accounts",
    listBookingJournals: "List booking journals",
    listAccountingAccounts: "List accounting accounts",
    viewBookingJournal: "View booking journal",
    membership: "Membership",
    nameOfAccount: "Name of account",
    contactUs: "Contact us",
    typeOfTreasuryAccount: "Type of treasury account",
    updateTreasuryAccountData: "Update treasury account data",
    viewTreasuryAccountsList: "View treasury accounts list",
    notification: "Notification",
    notifications: "Notifications",
    accept: "Accept",
    accessToCompany: "Access to company",
    activities: "Activities",
    answers: "Answers",
    close: "Close",
    companyInvitations: "Company invitations",
    hasReceivedANotification: "Has received a notification",
    hasReceivedAQuote: "Has received a quote",
    hasReceivedAnInvitation: "Has received an invitation",
    hasReceivedAnOrder: "Has received an order",
    newNotification: "New notification",
    noNotifications: "No notifications",
    noInvitations: "There are no invitations",
    other: "Other",
    quoteEvaluation: "Quote evaluation",
    quoteNotification: "Quote notification",
    approve: "Approve",
    reject: "Reject",
    contact: "Contact",
    contacts: "Contacts",
    basicBankAccountNumber: "Basic treasury account number",
    bankIdentifierCode: "Bank identifier code / Society for worldwide interbank financial telecommunication",
    listContacts: "List contacts",
    contactUUID: "Contact UUID",
    contactIdentity: "Contact identity",
    contactIsNotAnAppUser: "The contact is not an app user",
    contactType: "Contact type",
    contactUuidAndType: "Contact UUID and type",
    countryContact: "Country contact",
    createContact: "Create contact",
    createNewContact: "Create new contact",
    createContactCompanyStructure: "Create a company type contact structure",
    createContactPersonStructure: "Create a person type contact structure",
    deleteContact: "Delete contact",
    deleteSelected: "Delete selected",
    definingTheIdentityOfContact: "Defining the identity of the contact",
    definingTheInformationOfContact: "Defining the information of the contact",
    definingTheLegalInformationOfContact: "Defining the legal information of the contact",
    definingTheSettingsToDownloadQuotesAndInvoices: "Defining the settings to download quotes and invoices",
    dragOrClickOnTheBoxToAddTheCompanyLogo: "Drag or click on the box to add the company logo",
    editContact: "Edit contact",
    enterThePostalCodeOfTheCity: "Enter the postal code of the city",
    exportContacts: "Export contacts",
    exportEntryContacts: "Export accounting entry",
    extendChanges: "Extend changes",
    fileDownloadSettings: "File download settings",
    financialEntity: "Financial entity",
    identityOfContact: "Identity of contact",
    ifAddressDoesNotHaveANumber: "If the address does not have a number, enter 'nn' or 'NN'",
    whenNumberIsNotEntered: "When the number is not entered, it is represented by 'NN'",
    ifNecessaryEnterSomethingReferentialRegardingAddress: "If necessary, enter something referential regarding the address",
    informationOfContact: "Information of contact",
    internationalBankAccountNumber: "International bank account number",
    languageToDownload: "Language to download quote, order or invoice",
    legalInformationOfContact: "Legal information of contact",
    qrType: "QR-invoice type",
    shapesOrVersionsOfQR: "Shapes or versions of a QR-Invoice",
    basicCurrencyCompany: "Basic currency of the company",
    selectCompanyAndSave: "Select company and save",
    selectCompaniesToCreateContact: "Select the companies to which a new contact will be added",
    typeOfContact: "Type of contact",
    updateContactData: "Update contact data",
    uuidAndType: "UUID and type",
    userUuid: "User UUID",
    viewContact: "View contact",
    addresses: "Addresses",
    addAddress: "Add address",
    editAddress: "Edit address",
    deleteAddress: "Delete address",
    addressLabel: "Address label",
    addressType: "Address type",
    deliveryType: "Delivery",
    billingType: "Billing",
    otherType: "Other",
    defaultDeliveryAddress: "Default delivery address",
    setAsDefault: "Set as default",
    mainAddressBadge: "Main",
    noAddressesYet: "No addresses added yet",
    quote: "Quote",
    quotes: "Quotes",
    addQuote: "Add quote",
    approveQuote: "Approve quote",
    companyQuoteList: "Company quote list",
    createQuote: "Create quote",
    newQuote: "New quote",
    dateOfDocument: "Date of document, this can be modified later",
    editQuote: "Edit quote",
    enterADateOrSelectADefaultPaymentDeadline: "Enter a date or select a default payment deadline",
    expired: "Expired",
    exportQuotes: "Export quotes",
    generateQuote: "Generate quote",
    inTime: "In time",
    listQuotes: "List quotes",
    quoteDate: "Quote date",
    quoteGroups: "Quote groups",
    quoteNumber: "Quote number",
    quoteReference: "Quote reference",
    quoteStatus: "Quote status",
    quoteValidity: "Quote validity",
    rejectQuote: "Reject quote",
    sendQuote: "Send quote",
    updateQuote: "Update quote",
    viewQuote: "View quote",
    purchases: "Purchases",
    sales: "Sales",
    sale: "Sale",
    principal: "Principal",
    humanResources: "Human resources",
    closingJournal: "Closing journal",
    manuallyCreated: "Manually created",
    expenses: "Expenses",
    addExpense: "Add expense",
    createExpense: "Create expense",
    editExpense: "Edit expense",
    expenseDate: "Expense date",
    expenseGroups: "Expense groups",
    expenseNumber: "Expense number",
    expenseValidity: "Expense validity",
    invalidateExpense: "Invalidate expense",
    listExpenses: "List expenses",
    removeExpense: "Remove expense",
    updateExpense: "Update expense",
    validateExpense: "Validate expense",
    viewExpense: "View expense",
    addProviderInvoice: "Add provider invoice",
    createProviderInvoice: "Create provider invoice",
    editProviderInvoice: "Edit provider invoice",
    invalidateProviderInvoice: "Invalidate provider invoice",
    listProviderInvoices: "List provider invoices",
    myTreasuryAccount: "My treasury account",
    provider: "Provider",
    providerBankAccount: "Provider bank account",
    providerInvoiceDate: "Provider invoice date",
    providerInvoiceGroups: "Provider invoice groups",
    providerInvoiceStatus: "Provider invoice status",
    providerInvoiceValidity: "Provider invoice validity",
    providerInvoices: "Provider invoices",
    providerOrderNumber: "Provider order number",
    updateProviderInvoice: "Update provider invoice",
    validateProviderInvoice: "Validate provider invoice",
    viewProviderInvoice: "View provider invoice",
    addProviderOrder: "Add provider order",
    approveProviderOrder: "Approve provider order",
    cancelProviderOrder: "Cancel provider order",
    createProviderOrder: "Create provider order",
    editProviderOrder: "Edit provider order",
    generateProviderInvoice: "Generate provider invoice",
    generateProviderOrder: "Generate provider order",
    listProviderOrders: "List provider orders",
    providerOrderDate: "Provider order date",
    providerOrders: "Provider orders",
    providerOrderGroups: "Provider order groups",
    providerOrderReference: "Provider order reference",
    providerInvoiceReference: "Provider invoice reference",
    expenseReference: "Expense reference",
    providerOrderStatus: "Provider order status",
    updateProviderOrder: "Update provider order",
    viewProviderOrder: "View provider order",
    providerQuote: "Provider quote",
    providerQuotes: "Provider Quotes",
    listProviderQuotes: "Provider Quotes List",
    viewProviderQuote: "View provider quote",
    sourceQuoteNumber: "Source Quote Ref.",
    sourceCompany: "Source Company",
    acceptQuote: "Accept Quote",
    declineQuote: "Decline Quote",
    internalNotes: "Internal Notes",
    saveNotes: "Save Notes",
    providerQuoteAccepted: "Quote accepted, provider order created",
    providerQuoteDeclined: "Quote declined",
    confirmAcceptQuote: "Accept this quote? A provider order will be created automatically.",
    confirmDeclineQuote: "Decline this quote?",
    declineReasonLabel: "Reason for declining",
    declineReasonPlaceholder: "Please explain why you are declining this quote...",
    declineInvoiceReasonPlaceholder: "Please explain why you are declining this invoice...",
    declineReasonRequired: "A reason is required to decline.",
    recipientDecision: "Recipient's decision",
    decisionAccepted: "Accepted by recipient",
    decisionDeclined: "Declined by recipient",
    decisionDate: "Decision date",
    declineReason: "Decline reason",
    acceptanceStatus: "Acceptance status",
    acceptancePending: "Pending acceptance",
    acceptanceNotRequired: "Not required",
    acceptInvoice: "Accept Invoice",
    declineInvoice: "Decline Invoice",
    providerInvoiceAccepted: "Invoice accepted",
    providerInvoiceDeclined: "Invoice declined",
    confirmAcceptInvoice: "Accept this invoice?",
    confirmDeclineInvoice: "Decline this invoice?",
    seeProviderOrder: "See provider order",
    addVouchers: "Add voucher(s)",
    download: "Download",
    file: "File",
    lastModified: "Last modified",
    size: "Size",
    vouchers: "Vouchers",
    addFiles: "Add files",
    attachFiles: "Attach files",
    removeAll: "Remove all",
    uploadFiles: "Upload files",
    orders: "Orders",
    order: "Order",
    orderEvaluation: "Order evaluation",
    orderGroups: "Order groups",
    orderNotification: "Order notification",
    orderReference: "Order reference",
    orderStatus: "Order status",
    addOrder: "Add order",
    approveOrder: "Approve order",
    rejectOrder: "Reject order",
    cancelOrder: "Cancel order",
    companyListOfOrders: "Company list of orders",
    companyListOfInvoices: "Company list of invoices",
    companyListOfQuotes: "Company list of quotes",
    companyListOfProviderInvoices: "Company list of provider invoices",
    companyListOfProviderOrders: "Company list of provider orders",
    companyListOfProviderQuotes: "Company list of provider quotes",
    companyListOfExpenses: "Company list of expenses",
    companyListOfExpenseReports: "Company list of expense reports",
    createOrder: "Create order",
    delivery: "Delivery",
    deliveyAddress: "Delivery address",
    deliveryNote: "Delivery note",
    deliveryNotes: "Delivery notes",
    createDeliveryNote: "Create delivery note",
    noDeliveryNotesYet: "No delivery notes yet",
    delivered: "Delivered",
    notDelivered: "Not delivered",
    deliveryDate: "Delivery date",
    deliverAll: "Deliver all",
    quantityToDeliver: "Qty to deliver",
    quantityOrdered: "Qty ordered",
    quantityDelivered: "Qty delivered",
    quantityRemaining: "Qty remaining",
    alreadyFullyDelivered: "Already fully delivered",
    quantityReceived: "Qty received",
    quantityToEnter: "Qty to enter",
    allItemsReceived: "All items have been received",
    selectAtLeastOneQuantity: "Please select at least one quantity to enter",
    sendByEmail: "Send by email",
    sendToCustomer: "Send to customer",
    personalizedMessage: "Personalized message",
    deliveryAddressSelection: "Delivery address selection",
    mainAddress: "Main address",
    manageAddresses: "Manage addresses",
    storageCenterSelection: "Storage center selection",
    autoStockOut: "Automatic stock out",
    quantityInStock: "Quantity in stock",
    stockAvailability: "Stock availability",
    stockWarnings: "Stock warnings",
    deliveryProgress: "Delivery progress",
    deliveryComplete: "Delivery complete",
    deliveryPartial: "Partial delivery",
    notDeliveredYet: "Not delivered yet",
    deliveryAddressLabel: "Delivery address",
    sentAt: "Sent at",
    sentMethod: "Sent method",
    backToOrder: "Back to order",
    linesDelivered: "Lines delivered",
    createInvoiceFromSelection: "Create invoice from selection",
    ordersWillBeInvoicedTogether: "order(s) will be invoiced together",
    ordersSelected: "order(s) selected",
    editOrder: "Edit order",
    exportOrder: "Export order",
    exportOrders: "Export orders",
    generateInvoice: "Generate invoice",
    generateOrder: "Generate order",
    listOrders: "List orders",
    orderDate: "Order date",
    orderFile: "Order file",
    orderNumber: "Order number",
    selectExportType: "Select export type",
    sendOrder: "Send order",
    thisOptionIsUniqueAndNewInvoice: "This option is unique and a new invoice cannot be created from this order",
    updateOrder: "Update order",
    viewOrder: "View order",
    invoice: "Invoice",
    invoices: "Invoices",
    addInvoice: "Add invoice",
    amountDebt: "Amount debt",
    amountPaid: "Amount paid",
    companyInvoiceList: "Company invoice list",
    createInvoice: "Create invoice",
    editInvoice: "Edit invoice",
    exportInvoices: "Export invoices",
    exportProviderInvoices: "Export provider invoices",
    exportProviderOrders: "Export provider orders",
    exportProviderQuotes: "Export provider quotes",
    exportExpenses: "Export expenses",
    exportExpenseReports: "Export expense reports",
    debt: "Debt",
    fullyPaid: "Fully paid",
    invalidInvoices: "Invalid invoices",
    invalidateInvoice: "Invalidate invoice",
    invalidateProviderOrder: "Invalidate provider order",
    validateProviderOrder: "Validate provider order",
    invoiceGroups: "Invoice groups",
    invoiceDate: "Invoice date",
    invoiceNumber: "Invoice number",
    invoiceStatus: "Invoice status",
    invoiceValidity: "Invoice validity",
    listInvoices: "List invoices",
    notPayed: "Not payed",
    partiallyPaid: "Partially paid",
    payed: "Payed",
    thisInvoiceHasNoPayments: "This invoice has no payments",
    updateInvoice: "Update invoice",
    validated: "Validated",
    validateInvoice: "Validate invoice",
    viewInvoice: "View invoice",
    youWillBeAbleToUndoThisAction: "You will be able to undo this action",
    payment: "Payment",
    payments: "Payments",
    amountToPay: "Amount to pay",
    createNewPayment: "Create new payment",
    deleteSomePayment: "Delete some payment",
    doNotDeletePayments: "Do not delete any payment",
    makePayment: "Make payment",
    method: "Method",
    paymentDate: "Payment date",
    paymentMethod: "Payment method",
    save: "Save",
    sourceOfIncome: "Source of income",
    accountingAccountProductService: "Accounting account for the product or service",
    sourceTheAmount: "Source where the amount of money from the transaction is deposited or withdrawn",
    sourceTheAmountEntered: "Source where the amount of money for the transaction is entered",
    sourceTheAmountWithdrawn: "Source from which the transaction amount is withdrawn",
    cash: "Cash",
    card: "Card",
    payPal: "PayPal",
    transfer: "Transfer",
    mobile: "Mobile",
    thisOptionIncludeTaxPrice: "This option includes tax in the indicated price",
    thisOptionNotIncludeTaxPrice: "This option does not include tax in the indicated price",
    addOrRemoveContactCompanies: "Add or remove contact companies",
    notifyMe: "Notify me",
    background: "Background",
    inventory: "Inventory",
    viewProduct: "View product",
    storageCenter: "Storage center",
    listStorageCenter: "Storage center list",
    viewStorageCenter: "Storage center view",
    afterSalesService: "After-sales service",
    bookingJournals: "Booking journals",
    appLanguage: "App language",
    theUuidCanBeUsedToCreateNnewContact: "The UUID can be used to create a new contact",
    settingInformation: "Setting information",
    addOrRemoveCompanies: "Add/Remove companies",
    notGrouped: "Not grouped",
    notFiltered: "Not filtered",
    orderValidity: "Order validity",
    expiration: "Expiration",
    quoteExpiration: "Quote expiration",
    orderExpiration: "Order expiration",
    invoiceExpiration: "Invoice expiration",
    discountTotal: "Discount total",
    addService: "Add service",
    addProduct: "Add product",
    noRecords: "No records",
    quantityMinimumForRebate: "Minimum quantity for rebate",
    nonExistentRebateNegativePrice: "Non existent rebate for negative price",
    thisOptionRebateIsFixedAmount: "This option indicates that the rebate is a fixed amount",
    thisOptionRebateIsPercentage: "This option indicates that the rebate is a percentage",
    thisOptionRebateIsNone: "This option indicates that the rebate is none",
    totalAfterRebates: "Total after rebates",
    calculator: "Calculator",
    enterRebate: "Enter rebate",
    reference: "Reference",
    newOrder: "New order",
    invoiceReference: "Invoice reference",
    newInvoice: "New invoice",
    providerOrderValidity: "Provider order validity",
    expenseStatus: "Expense status",
    newProviderOrder: "New provider order",
    newProviderInvoice: "New provider invoice",
    newExpense: "New expense",
    viewVoucher: "View voucher",
    informationAdditional: "Additional information",
    no: "No",
    bank: "Bank",
    fullNameBankAccountHolder: "Full name of the bank account holder",
    bankAccountHolder: "Bank account holder",
    isNecessaryToHaveReferenceToActivateOption: "It is necessary to have a reference to activate this option",
    isNecessaryToHaveAtLeastTwoTreasuryAccountsToActivateOption:
      "It is necessary to have at least two treasury accounts to activate this option",
    none: "None",
    undefined: "Undefined",
    colorCombinationForDesignOfDocumentToDownload: "Color combination for the design of the document to download",
    all: "All",
    lettersTitlesSubtitles: "Letters titles subtitles",
    firstBar: "First bar",
    secondBar: "Second bar",
    barLetters: "Bar letters",
    qrIbanAndQrReference: "QR-IBAN and QR-Reference",
    ibanAndStructuredCreditorReference: "IBAN and Structured Creditor Reference (SCOR)",
    ibanWithoutReference: "IBAN Without Reference",
    cashAccount: "Cash account",
    postalAccount: "Postal account",
    bankAccount: "Bank account",
    currentAccount: "Shareholder current account",
    listProducts: "List products",
    category: "Category",
    categories: "Categories",
    listCategories: "List categories",
    tags: "Tags",
    variants: "Variants",
    photography: "Photography",
    reminder: "Reminder",
    reminders: "Reminders",
    paymentStatus: "Payment status",
    year: "Year",
    createReminder: "Create reminder",
    updateReminder: "Update reminder",
    makeCopy: "Make copy",
    reminderTotal: "Reminder total",
    inDispute: "In dispute",
    addCategory: "Add category",
    addStorageCenter: "Add storage center",
    addBookingJournal: "Add booking journal",
    qtyAssets: "QTY assets",
    qtyServices: "QTY services",
    qtyProducts: "QTY products",
    viewCategory: "View category",
    editCategory: "Edit category",
    deleteCategory: "Delete category",
    names: "Names",
    listCategoryItems: "List category items",
    editListing: "Edit listing",
    updateCategoryItemList: "Update category item list",
    updateCategory: "Update category",
    nameInOtherLanguages: "Name in other languages",
    enterInLanguageWant: "Enter in the language you want",
    enterNameOfRequestedLanguages: "Enter the name of the requested languages",
    enterDesiredValuePressEnterAdd: "Enter the desired value and press enter to add it",
    enterOrModifyInLanguage: "Enter or modify in the language you want",
    general: "General",
    categoryName: "Category name",
    categoryType: "Category type",
    createCategory: "Create category",
    editProduct: "Edit product",
    deleteProduct: "Delete product",
    productReferencePictures: "Product reference pictures",
    code: "Code",
    sku: "SKU",
    codebar: "Barcode",
    color: "Color",
    unit: "Unit",
    price: "Price",
    priceSale: "Sale price",
    pricePurchase: "Purchase price",
    fixed: "Fixed",
    productName: "Product name",
    productDetails: "Product details",
    advanced: "Advanced",
    addVariant: "Add variant",
    uniqueProductCodeAssignedByCompany: "Unique product code assigned by the company",
    additionalCommentDescriptionProductVariant: "Additional comment or description for the product variant",
    selectDiscountTypeAppliedToProduct: "Select a discount type to apply to this product",
    discountType: "Discount type",
    selectDiscountTypeThatWillAppliedProduct: "Select a discount type that will be applied to this product",
    noDiscount: "No discount",
    setDiscountPercentage: "Set discount percentage",
    fixedDiscountedAmount: "Fixed discounted amount",
    quantityMinimumDiscount: "Minimum quantity for discount",
    createProduct: "Create product",
    dropFilesHereOrClickUpload: "Drop files here or click to upload",
    dropFileHereOrClickUpload: "Drop file here or click to upload",
    uploadUpToFiles: "Upload up to 10 files",
    success: "Success",
    addNewProductVariant: "Add new product variant",
    editVariant: "Edit variant",
    editProductVariant: "Edit product variant",
    updateProduct: "Update product",
    saveVariant: "Save variant",
    listServices: "List services",
    viewService: "View service",
    editService: "Edit service",
    deleteService: "Delete service",
    serviceReferencePictures: "Service reference pictures",
    serviceName: "Service name",
    serviceDetails: "Service details",
    createService: "Create service",
    updateService: "Update service",
    uniqueServiceCodeAssignedByCompany: "Unique service code assigned by the company",
    selectDiscountTypeAppliedToService: "Select a discount type to apply to this service",
    expenseAccount: "Expense account",
    vatAccount: "VAT account",
    accountProduct: "Product account",
    accountingAccount: "Accounting account",
    accountingAccounts: "Accounting accounts",
    accountingAccountPurchases: "Accounting account for purchases",
    accountingAccountSales: "Accounting account for sales",
    addAccountingAccount: "Add accounting account",
    rangeAllowedCodes: "Range of allowed codes",
    effective: "Effective accounting",
    tdfn: "Net tax debt rate (TDFN)",
    taf: "Taux forfaitaire (TaF)",
    vatAccountingType: "VAT accounting type",
    theVatRegimeCanOnlyChangedOnceAYear: "The VAT regime can only be changed once a year, just before starting a new accounting year",
    debit: "Debit",
    credit: "Credit",
    customerReceivable: "Customer receivable",
    providerReceivable: "Provider receivable",
    vatDue: "VAT due",
    vatRecoverable: "VAT recoverable",
    declarationMethod: "Declaration method",
    onInvoicing: "Based on invoicing (on invoicing)",
    onCashing: "Based on payments received (on receipt)",
    valid: "Valid",
    invalid: "Invalid",
    colorIsInvalid: "Invalid color",
    theValueIsNotAValid: "The value is not valid",
    theValueIsNotAValidUUIDOrNameUser: "The value is not a valid UUID or username",
    theValueIsAtLeast8Digits: "The value is at least 8 digits",
    theValueDoesNotMatch: "The value does not match",
    theValueAlreadyExists: "The value already exists",
    limitFilesMaximum: "Maximum limit of 10 files",
    required: "Required",
    theValueIsRequired: "The value is required",
    allValuesRequired: "All values are required",
    colorIsRequired: "Color is required",
    requirementsIsRequired: "Blocks are required",
    paymentsIsRequired: "Blocks are required",
    contentsToRequirementIsRequired: "Block content is required",
    transaction: "Transaction",
    createNewPaymentForInvoice: "Create new payment for invoice",
    createNewPaymentForProviderInvoice: "Create new payment for provider invoice",
    addTransaction: "Add transaction",
    accountingEntry: "Accounting entry",
    amountAvailable: "Amount available",
    selectExistingTransaction: "Select existing transaction",
    totalAmountDebt: "Total amount debt",
    presetCurrency: "Preset currency",
    deposit: "Deposit",
    deposition: "Deposition",
    depositAmount: "Deposit amount",
    pastTransactions: "Past transactions",
    noPastTransactions: "No past transactions",
    selectTransaction: "Select a transaction",
    providerInvoice: "Provider invoice",
    expense: "Expense",
    enterNewTransaction: "Enter a new transaction",
    useExistingTransaction: "Use an existing transaction",
    transactionToRecordPayment: "Transaction to be able to record the payment",
    amountMoneyEnteredInTransaction: "Amount of money entered in the transaction",
    amountMoneyWithdrawnInTransaction: "Amount of money withdrawn in the transaction",
    identifiedTransactions: "Identified transactions",
    unidentifiedTransactions: "Unidentified transactions",
    totalDepositAmount: "Total deposit amount",
    makeCorrespondingPayment: "Make the corresponding payment",
    balance: "Balance",
    accountingEntries: "Accounting entries",
    contactBalance: "Contact balance",
    accountStatement: "Account statement",
    accountStatements: "Account statements",
    invoiceIssuance: "Invoice issuance",
    saleIssuance: "Sale issuance",
    providerInvoiceIssuance: "Provider invoice issuance",
    expenseIssuance: "Expense issuance",
    allocationInvoiceReminder: "Allocation for invoice reminder",
    transactionToPostFinance: "PostFinance account transaction",
    transactionFormPostFinance: "PostFinance account transaction",
    balancePrevious: "Previous balance",
    includeOpeningBalance: "Include opening balance",
    balanceFavorContact: "Balance in your favor",
    balanceFavorCompany: "Balance in our favor",
    addCredit: "Add credit",
    addDebit: "Add debit",
    createClientCredit: "New credit entry",
    createClientDebit: "New debit entry",
    unidentifiedTransactionToRegisterInContact: "Unidentified transaction to register in the contact",
    draft: "Draft",
    revertToDraft: "Revert to draft",
    beforeCreatingProviderInvoice: "Before creating an provider invoice",
    beforeCreatingProviderOrder: "Before creating an provider order",
    beforeCreatingExpense: "Before creating an expense",
    viewPdf: "View PDF",
    viewOriginalPdf: "View original PDF",
    documentPdf: "Document PDF",
    viewReferencePdf: "View reference PDF",
    referencePdf: "Reference PDF",
    invalidFileType: "File in different format",
    fileInDifferentFormatImg: "File in different format. Allowed file types: jpeg, jpg or png",
    fileSizeNotAllowed: "File too large. Maximum file size: 1 MB",
    fileInDifferentFormatPdf: "File in a different format. File format: pdf",
    fileIsTooBig: "The file is too big. Maximum file size: 10 MB",
    addDocument: "Add document",
    validate: "Validate",
    invalidate: "Invalidate",
    listing: "Listing",
    creation: "Creation",
    accounting: "Accounting",
    generalLedger: "General ledger",
    bookingJournal: "Booking journal",
    label: "Label",
    multipleWriting: "Multiple writing",
    simplifiedMultipleWriting: "Simplified multiple writing",
    availableAmount: "Available amount",
    level: "Level",
    coefficient: "Coefficient",
    leave: "Leave",
    title: "Title",
    writingSimple: "Writing simple",
    writingMultiple: "Writing multiple",
    writingSimplifiedMultiple: "Writing simplified multiple",
    taxIncluded: "Whith VAT",
    taxExcluded: "Without VAT",
    taxFee: "Tax fee (VAT)",
    vatOptions: "VAT options",
    interest: "Interest",
    penalty: "Penalty",
    refund: "Refund",
    creditNote: "Credit note",
    customerInterest: "Customer interest",
    customerPenalty: "Customer penalty",
    customerRefund: "Customer refund issued",
    providerPayment: "Provider payment issued",
    providerCreditNote: "Provider credit note issued",
    providerInterest: "Provider interest",
    providerPenalty: "Provider penalty",
    providerRefund: "Provider refund issued",
    customerPayment: "Payment received from a customer",
    customerCreditNote: "Customer credit note issued",
    transactionType: "Transaction type",
    resend: "Send again",
    information: "Information",
    generalInformation: "General information",
    vatCalculationPeriod: "VAT calculation period",
    dependsWhetherCompanySubjectTax: "It depends on whether the company is subject to tax",
    dependsCompanySpecialVatRegime: "It depends on the company's special VAT regime",
    dependsCompanyVatCalculationPeriod: "It depends on the company's VAT calculation period",
    upcomingVatStatement: "Upcoming VAT statement",
    deadline: "Deadline",
    quarter: "Quarter",
    semester: "Semester",
    chartAccounts: "Chart of accounts",
    vatStatement: "VAT statement",
    listVatStatements: "List VAT statements",
    manual: "Manual",
    vatSettingsMap: "VAT settings map",
    listPeriodsStatement: "List of periods for VAT statement",
    vatAmount: "VAT",
    vatAmountDue: "VAT amount due",
    regime: "Regime",
    calculation: "Calculation",
    tickets: "Tickets",
    pendingVatTickets: "Pending VAT tickets",
    orphansOnly: "Orphans only",
    formLine: "Form line",
    vatShort: "VAT",
    side: "Side",
    accrual: "Accrual",
    open: "Open",
    filed: "Filed",
    closed: "Closed",
    listPeriodStatement: "List of statement period",
    exportStatementPeriod: "Export of statement period",
    editAccountingSettings: "Edit accounting settings",
    brand: "Brand",
    features: "Features",
    createStorageCenter: "Create storage center",
    updateStorageCenter: "Update storage center",
    editStorageCenter: "Edit storage center",
    addInventory: "Add to inventory",
    storagePurchase: "Storage for purchase",
    operations: "Operations",
    storageOperations: "Storage operations",
    listOperationsStorageCenter: "List of operations of a storage center",
    sourceLocation: "Source location",
    destinationLocation: "Destination location",
    source: "Source",
    invalidated: "Invalidated",
    in: "In",
    out: "Out",
    adjustment: "Adjustment",
    stockEntry: "Stock entry",
    stockExit: "Stock exit",
    stockTransfer: "Stock transfer",
    sourceStorageCenter: "Source storage center",
    destinationStorageCenter: "Destination storage center",
    availableStock: "Available stock",
    quantityToTransfer: "Quantity to transfer",
    addLine: "Add a line",
    selectProduct: "Select a product",
    removeLine: "Remove",
    providerOrder: "Provider order",
    updatePos: "Update POS",
    pos: "POS",
    listPOS: "List POS",
    createPOS: "Create POS",
    createNewPOS: "Create new POS",
    viewPOS: "View POS",
    createSale: "Create sale",
    pointOfSale: "Point of sale",
    selectProducts: "Select products",
    selectedItems: "Selected items",
    noItemsSelected: "No items selected",
    step1: "Step 1",
    step2: "Step 2",
    paymentMethods: "Payment methods",
    received: "Received",
    totalPaid: "Total paid",
    totalCash: "Total cash",
    totalCard: "Total card",
    paymentCalculation: "Payment calculation",
    completeSale: "Complete sale",
    listOfSales: "List of sales",
    noTransactionsToday: "No transactions today",
    totalTransactions: "Total transactions",
    active: "Active",
    inactive: "Inactive",
    startCreatingNewPOSForYourCompany: "Start creating new POS for your company",
    add: "Add",
    change: "Change",
    cashier: "Cashier",
    saleNumber: "Sale number",
    viewSale: "View sale",
    return: "Return",
    createNewSale: "Create new sale",
    defaultCustomerSale: "Default customer of a sale",
    heWantsAccessApplicationLink: "He wants to access the application via a link",
    security: "Security",
    signOutAllDevices: "Sign out of all devices",
    editDeadlinePaymentParameter: "Edit payment deadline parameter",
    editFeatureParameter: "Edit feature parameter",
    editMeasureUnitParameter: "Edit measurement unit parameter",
    addMeasureUnitParameter: "Add measurement unit parameter",
    areYouSureYouWantToDeleteThisRecord: "Are you sure you want to delete this record?",
    youWontBeAbleToRevertThis: "You won't be able to revert this action",
    yesDeleteIt: "Yes, delete it",
    confirmPurchase: "Confirm purchase",
    confirmPurchaseDesignMessage: "Do you want to confirm the purchase of this design?",
    yesPurchase: "Yes, purchase",
    companyColorSettings: "Company color settings",
    saveColors: "Save colors",
    companyDesignSettings: "Company design settings",
    currentDesign: "Current design",
    setAsCurrent: "Set as current",
    subjectToVat: "Subject to VAT",
    companySwitchingNotAvailableInView:
      "Company switching is not available in this view; it can only be performed from the company’s general views",

    // Start sentence
    selectOneOption: "Select one of the options,",
    iAgree: "I agree &",
    youWantToChangeOrderStatusTo: "Do you want to change the order status to",
    createdAt: "Created at",
    updatedAt: "Updated at",
    validUntil: "Valid until",
    clickOn: "Click on",
    thisContactWillOnlyBeRegisteredInCompany: "This contact will only be registered in the company",
    securedPaymentBy: "Secured payment by",
    anInvitationWillBeSent: "An invitation will be sent to access the company",
    ifYouNeedMoreInfo: "If you need more information, check at",
    theInvitationToAccess: "The invitation to access the company by the user",
    theQuoteThatYouSent: "The quote you sent to the company",
    youHaveAlreadyEvaluatedOrder: "You have already evaluated the company's order",
    youHaveAlreadyEvaluatedQuote: "You have already evaluated the company's quote",
    youHaveAlreadyRespondedTo: "You have already responded to",
    youHaveReceivedAQuote: "You have received a quote from the company",
    ifYouDoNotWishToExtendContactModificationsToOtherCompanies:
      "If you do not wish to extend contact modifications to other companies, do not check any and select",
    youWantToChangeQuoteStatusTo: "Do you want to change the quote status to",
    youWantToChangeProviderOrderStatusTo: "Do you want to change the provider order status to",
    theOrderThatYouSent: "The order you sent to the company",
    youHaveReceivedAnOrder: "You have received an order from the company",
    theCurrentCompanyIs: "The current company is",
    toCreateA: "To create a",
    createdBy: "Created by",
    groupBy: "Group by",
    checkOrUncheck: "Check or uncheck the",
    ifYouWishChangeVatRegimePleaseContact: "If you wish to change the VAT regime, you need to contact",
    ifYouInvalidateInvoice: "If you invalidate the invoice",
    ifYouInvalidateProviderOrder: "If you invalidate the provider order",
    ifYouInvalidateProvaiderInvoice: "If you invalidate the provider invoice",
    ifYouInvalidateExpense: "If you invalidate the expense",
    the: "The",
    planYourBusinessApplications: "Plan your business applications by choosing one of",
    yourAccountIsNotVerified: "Your account is not verified. Validate your account through your email address by clicking the button",
    chargeFor: "Charge for",
    serverErrorOccurred: "A server error occurred",
    noResponseServer: "No response received from the server",
    serviceTemporarilyUnavailable: "The service is temporarily unavailable. Please try again.",
    records: "Records",
    invitations: "Invitations",
    consignment: "Consignment",
    consignmentReturn: "Consignment return",
    consignments: "Consignments",
    listConsignments: "Consignment list",
    commissionType: "Commission type",
    commissionRate: "Commission rate",
    newConsignment: "New agreement",
    receiveProducts: "Receive products",
    returnProducts: "Return unsold",
    generateReport: "Generate report",
    quantitySold: "Qty sold",
    quantityReturned: "Qty returned",
    quantityAvailable: "Qty available",
    quantityToReturn: "Qty to return",
    totalSoldValue: "Total sold value",
    commissionAmount: "Commission amount",
    amountDueToProvider: "Amount due to provider",
    closeAgreement: "Close agreement",
    consignmentAgreement: "Consignment agreement",
    fixedPrice: "Fixed price",
    documents: "Documents",
    document: "Document",
    listDocuments: "Document list",
    uploadDocument: "Upload document",
    assignDocument: "Assign document",
    archiveDocument: "Archive document",
    unarchiveDocument: "Unarchive document",
    ignoreDocument: "Ignore document",
    unignoreDocument: "Restore document",
    inbox: "Inbox",
    archives: "Archives",
    youWantToIgnoreThisDocument: "Do you want to ignore this document?",
    youWantToUnignoreThisDocument: "Do you want to restore this document?",
    youWantToArchiveThisDocument: "Do you want to archive this document?",
    youWantToUnarchiveThisDocument: "Do you want to unarchive this document?",
    successfullyIgnored: "Document successfully ignored",
    successfullyUnignored: "Document successfully restored",
    successfullyArchived: "Document successfully archived",
    successfullyUnarchived: "Document successfully unarchived",
    cannotIgnoreDocument: "Cannot ignore document",
    cannotIgnoreDocumentWithAssignments: "This document has active assignments. Remove them before ignoring it.",
    deleteDocument: "Delete document",
    fileName: "File name",
    assignedTo: "Assigned to",
    assigned: "Assigned",
    preview: "Preview",
    downloadFile: "Download file",
    upload: "Upload",
    assign: "Assign",
    documentType: "Document type",
    documentReference: "Document reference",
    enterDocumentReference: "Enter document reference",
    partiallyProcessed: "Partially processed",
    processed: "Processed",
    originalFile: "Original file",
    documentDate: "Document date",
    uploadedOn: "Uploaded on",
    documentDetails: "Document details",
    documentName: "Document name",
    previewNotAvailable: "Preview not available",
    documentUpdated: "Document updated",
    createFromDocument: "Create from document",
    attachExistingDocument: "Attach existing document",
    selectDocumentToAttach: "Select a document to attach",
    documentAttached: "Document attached successfully",
    noDocumentsAvailable: "No documents available",
    attach: "Attach",
    uploadNewPdf: "Upload new PDF",
    removeDocument: "Remove",
    confirmRemoveVoucher: "Remove this document?",
    brands: "Brands",
    youWantToDeleteThisBrand: "Do you want to delete this brand?",
    listBrands: "Brand list",
    createBrand: "Create brand",
    searchBrand: "Search brand",
    clear: "Clear",
    sortBy: "Sort by",
    show: "Show",
    perPage: "per page",
    showing: "Showing",
    of: "of",
    nameRequired: "Name required",
    nameIsRequired: "Name is required",
    updateBrand: "Update brand",
    enterBrandName: "Enter brand name",
    logoUrlHint: "Enter logo URL",
    processing: "Processing",
    editBrand: "Edit brand",
    logoUrl: "Logo URL",
    addBrand: "Add brand",
    selectBrand: "Select brand",
    noBrandsAvailable: "No brands available",

    // End sentence
    companyPleaseEvaluateQuote: ", please evaluate the quote.",
    theAssociatedAccountingEntriesWillBeDeletedInvoice:
      ", the associated accounting entries will be deleted. This means that you will not be able to make payments or generate reminder fees related to this invoice.",
    theAssociatedAccountingEntriesWillBeDeletedProviderInvoice:
      ", the associated accounting entries will be deleted. This means that you will not be able to make payments or generate reminder fees related to this provider invoice.",
    theAssociatedAccountingEntriesWillBeDeletedExpense:
      ", the associated accounting entries will be deleted. This means that you will not be able to make payments or generate reminder fees related to this expense.",
    theAssociatedProductsWillBeRemoved:
      ", the associated products will be removed. This means they will not be recorded in the inventory of the storage centers related to that supplier order.",
    ifYouWishToSaveTheChangesMade: "if you wish to save the changes made.",
    youWantToRun: "that you want to run.",
    toContinue: "to continue.",
    waitAMomentToVerifyYourAccess: "wait a moment to verify your access.",
    hasSentARequestForAccessToTheFollowingCompany: "has sent a request for access to the following company, please respond.",
    ifYouWantToSaveTheNewQuote: "if you want to save the new quote.",
    ifYouWantToSaveTheNewQuoteWithTheChangesMade: "if you want to save the new quote with the changes made.",
    ifYouWantToSaveTheNewInvoiceWithTheChangesMade: "if you want to save the new invoice with the changes made.",
    ifYouWantToSaveTheNewExpense: "if you want to save the new expense.",
    ifYouWantToSaveTheNewProviderInvoice: "if you want to save the new provider invoice.",
    ifYouWantToSaveTheNewProviderOrder: "if you want to save the new provider order.",
    ifYouWantToSaveTheNewProviderOrderWithTheChangesMade: "if you want to save the new provider order with the changes made.",
    ifYouWantToSaveTheNewProviderInvoiceWithTheChangesMade: "if you want to save the new provider invoice with the changes made.",
    ifYouWantToSaveTheNewOrder: "if you want to save the new order.",
    ifYouWantToSaveTheNewOrderWithTheChangesMade: "if you want to save the new order with the changes made.",
    companyPleaseEvaluateTheOrder: "company, please evaluate the order.",
    ifYouWantToSaveTheNewInvoice: "if you want to save the new invoice.",
    youWillNotBeAbleToRemoveItFromThisCompany:
      ", you will not be able to remove it from this company, but you can select the other companies.",
    inThisCategory: "in this category.",
    theCompanyContainTreasutyAccount: "the company must contain at least one treasury account.",
    toBeAddedInOrderToDownloadTheInvoice: "must be added to download the invoice.",

    // All sentence
    enterNewPassword: "Enter a new password.",
    ifYouChangeYourMind: "If you change your mind, request a new application to be sent.",
    messageWillBeSentYourEmailToRecoverAccount:
      "A message will be sent to your email to recover the account, please check your email. You will be redirected to the login page.",
    yuouCanNowStartUsingApp: "You can now start using the app, you will be redirected to the home page shortly.",
    newCompanyIsSelectedByDefault: "The new company is selected by default and redirected to the main page.",
    notificationWillBeDeleted: "The invitation notification to access the company will be deleted.",
    theAppWillBeTranslated:
      "The application will be translated into the selected language, except for the information entered in the documents.",
    userWillRespondInvitation: "The user will respond whether they accept or decline the invitation to access the company.",
    youWillNotBeAbleToUndo: "You will not be able to undo this action.",
    toValidateYourAccount: "To validate your account, a message will be sent to your email address where you can verify it.",
    pleaseCheckEmailToValidateAccount: "Please check your email, we have sent a message to validate your account.",
    anEmailSentToValidateAccount: "An email has been sent to you to validate your account.",
    validatedAccountForLoggedInUser: "Account validated for the logged-in user, redirecting to the main page.",
    validatedAccountForADifferentUser:
      "Account validated for a different user than the one currently logged in, redirecting to the login page.",
    validatedVerifiedForAUserWhoHasNotLoggedIn: "Validated and verified for a user who has not logged in, redirecting to the login page.",
    newServicesWithinTheSameApp: "New services within the same application.",
    soonYouWillBeAbleToAccessNewFunctionalities: "Soon you will be able to access new functionalities within the application.",
    pleaseCorrectThePathOfThePageInOrderToAccess: "Please correct the page path to access the application.",
    pleaseTryAgainLater: "Please try again later.",
    validTokenAutomaticLoginRedirectedDashboard: "Valid token, automatic login, redirected to the dashboard page.",
    redirectingToLogin: "Redirecting to the login page.",
    willNotBeAbleToReturnUntilYouLogin: "You will not be able to return until you log in again.",
    enterEmailWhetherBelongsRegisteredUserOrNot:
      "Enter the email address, whether it belongs to a registered user or not. A notification will be sent to access the application and the company, either within the application (if the user exists) or to the provided email.",
    theFileMustBeFormat: "The file must be in jpeg, jpg, or png format.",
    ifYouHaveAnyQuestionsContactUs: "If you have any questions, you can contact us.",
    noNotificationsSeenYet: "No notifications have been seen yet.",
    thereAreNoNotifications: "No notifications have been received yet.",
    invitationsHaveNotReceived: "Invitations have not yet been received.",
    byDefaultValuesOfTheCompanyAreTaken: "By default, the company values are taken.",
    selectTheOptionsThatBestConsiderWhenDownloading:
      "Select the options you consider best when downloading a quote or an invoice in PDF format.",
    notificationsAboutInvitationsToSubscribe: "Notifications about invitations to subscribe and gain access to a company.",
    whenCreatingAContactByUUID:
      "When creating a contact by UUID, you will not be able to modify certain fields depending on the type: person (name, surname, and email) and company (name).",
    youCanDirectlyEnterUUIDOfAUserOrCompanyToAddAsContact:
      "You can directly enter the UUID of a user or company to add as a contact. Otherwise, choose the type of contact you want to create.",
    descriptionCreateQuote: "Enter the following details, they are required to create a new quote.",
    descriptionCreateOrder: "Enter the following details, they are required to create a new order.",
    descriptionCreateInvoice: "Enter the following details, they are required to create a new invoice.",
    sorryLooksLikeThereAreSomeErrorstryAgain: "Sorry, it looks like some errors were detected, please try again.",
    sorryLooksLikeThereAreSomeErrorsTrySolve: "Sorry, it looks like some errors were detected, please try to resolve them.",
    sorryThereIsNothingToAdd: "Sorry, there is nothing to add, please try again.",
    thankYouVeryMuchForSubscribingRedirectingToPreviousPage: "Thank you very much for subscribing, redirecting to the previous page.",
    actionCompletedReturningToPage: "Action completed, returning to the page.",
    actionCompletedRedirectingToPage: "Action completed, redirecting to the page.",
    pleaseModifyAddOrDeleteFieldsFromQuote: "Please modify, add, and/or delete the fields you want from the quote.",
    thisOptionIsUniqueAndNewOrderCannotBeCreatedFromThisQuote: "This option is unique, and a new order cannot be created from this quote.",
    descriptionCreateProviderInvoice: "Enter the following details, they are required to create a new provider invoice.",
    pleaseModifyAddOrDeleteFieldsFromProviderInvoice: "Modify, add, and/or delete the fields you want from the provider invoice.",
    pleaseModifyAddOrDeleteFieldsFromExpense: "Modify, add, and/or delete the fields you want from the expense.",
    descriptionCreateExpense: "Please enter the following details, they are required to create a new expense.",
    descriptionCreateProviderOrder: "Enter the following details, they are required to create a new provider order.",
    pleaseModifyAddOrDeleteFieldsFromProviderOrder: "Modify, add, and/or delete the fields you want from the provider order.",
    fileFormatMaximum10MBPerFile: "File format is '.pdf' and the maximum file size is 10 MB.",
    someOfTheUploadedFilesDoNotMeetTheRequiredCharacteristics: "Some of the uploaded files do not meet the required characteristics.",
    pleaseModifyAddOrDeleteFieldsFromOrder: "Modify, add, and/or delete the fields you want from the order.",
    pleaseModifyAddOrDeleteFieldsFromInvoice: "Modify, add, and/or delete the fields you want from the invoice.",
    thisAmountCanNotBeGreater: "This amount cannot be greater than the total debt of the invoice.",
    amountMinOfDueAndTransaction:
      "Minimum of the invoice due amount and the transaction amount (e.g. due $50, transaction $100 → $50; due $150, transaction $100 → $100).",
    toCreateAnDocument: "To create a document, the company must contain at least one treasury account.",
    newContactWwillAddedToCompanyAndSelectDefault: "New contact will be added to the company and selected as default, returning to page.",
    youHaveSuccessfullyResetYourPassword:
      "You have successfully reset your password, you can now log in again. You will be redirected to the login page.",
    ifNoAmountIsEnteredTheValueWillBeZero: "If no amount is entered, the value will be 0.",
    ifYouWishYouCanAssignNameInLanguagesNecessary: "If you wish, you can assign the name in the languages ​​you consider necessary.",
    productNameRequiredAndRecommendedUnique: "A product name is required, and it is recommended to be unique.",
    addProductToCategory: "Add a product to a category.",
    addTagsToProduct: "Add tags to the product, they are optional.",
    setProductMediaGallery: "Set up the product media gallery.",
    serviceNameRequiredAndRecommendedUnique: "A service name is required, and it is recommended to be unique.",
    addServiceToCategory: "Add a service to a category.",
    addTagsToService: "Add tags to the service, they are optional.",
    setServiceMediaGallery: "Set up the service media gallery.",
    aCategoryContainServicesProducts: "A category can contain both services and products.",
    ifSoAdditionalInformationRequired: "If so, additional information will be required.",
    toPerformAnySubsequentActionWithInvoice:
      "To perform any subsequent action with the invoice, it must be revalidated by specifying the accounting accounts corresponding to each associated product and/or service.",
    toPerformAnySubsequentActionWithProviderInvoice:
      "To perform any subsequent action with the provider invoice, it must be revalidated by specifying the accounting accounts corresponding to each associated product and/or service.",
    toPerformAnySubsequentActionWithExpense:
      "To perform any subsequent action with the expense, it must be revalidated by specifying the accounting accounts corresponding to each associated product and/or service.",
    toPerformAnyFurtherActionProviderOrder:
      "To perform any further action with the provider order, it will be necessary to create a copy from it.",
    validatingInvoiceSystemWillCreateToFollowingAccountingEntries:
      "By validating the invoice, the system will create the following accounting entries. Confirm the accounting accounts for each service or product in the invoice.",
    validatingProviderInvoiceSystemWillCreateToFollowingAccountingEntries:
      "By validating the provider invoice, the system will create the following accounting entries. Confirm the accounting accounts for each service or product in the provider invoice.",
    validatingExpenseSystemWillCreateToFollowingAccountingEntries:
      "By validating the expense, the system will create the following accounting entries. Confirm the accounting accounts for each service or product in the expense.",
    allowedFileTypes: "Allowed file types: png, jpg, jpeg.",
    whenYouUploadPdfFilesTheyArePlacedReferenceSupplieIinvoiceCreationform:
      "When you upload one or more PDF files, they are placed as a reference in the supplier's invoice creation form.",
    someFilesIncorrectlyFormattedAndTooLarge: "Some files are incorrectly formatted, and others are too large.",
    someFilesIncorrectlyFormatted: "Some files are incorrectly formatted.",
    someFilesTooLarge: "Some files are too large.",
    searchSelectContact: "Search and select a contact.",
    accountingBookWithTotalAccountingEntriesCompany: "Accounting book with the total accounting entries of the company.",
    byDefaultSimpleWriting: "By default a simple writing is created.",
    selectAllPossibleOptions: "Select all possible options.",
    newManualAccountingBookCreated: "A new manual accounting book will be created.",
    selectOptionToEnableForm: "Select an option to enable the form.",
    selectApplicableScheme: "Select the applicable scheme.",
    enterApplicableVatRate: "Enter the applicable VAT rate.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderOrder:
      "The system is adding the following products to the company's inventory. Please confirm the storage centers for each product on the provider order.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderInvoice:
      "The system is adding the following products to the company's inventory. Please confirm the storage centers for each product on the provider invoice.",
    addPaymentUsingCashOrCardOrDeposit: "Add a payment using cash, card or deposit.",

    // Lowercase sentences
    yearl: "year",
    years: "years",
    hour: "hour",
    hours: "hours",
    minute: "minute",
    minutes: "minutes",
    items: "items",
    groups: "groups",
    selected: "selected",
    accountNeedsA: "account needs a",
    options: "options",
    with: "with",
    bestCustomers: "best customers",
    byRecentUpdates: "by recent updates",
    byTimeRange: "by time range",
    template: "template",
    evaluated: "evaluated",
    noMailFound: "no mail found",
    report: "report",
    reports: "reports",
    requestOnAccess: "request on company access, your response was",
    userHasBeen: "has been",
    yourAnswerHasBeen: ", your answer has been",
    toUser: "to user",
    hasBeen: "has been",
    byYear: "by year",
    or: "or",
    quotesToExpireThisMonth: "quotes to expire this month",
    worstCustomers: "worst customers",
    button: "button",
    termsAndConditions: "terms and conditions",
    and: "and",
    ourServicesOrRequesting: "our services or requesting a new one",
    toAddOrRemoveCategory: "that you want to add or remove from the category",
    orCall: "or call",
    invoicesNotYetPaid: "invoices not yet paid",
    collections: "collections",
    from: "from",

    // Interrogative sentences
    isDeliveryAddressTheSameAsCustomersAddress: "Is the delivery address the same as the customer's address?",
    youWantLogOut: "Do you want to log out?",
    doesItTakeALongTimeToLoadTheApp: "Does it take a long time to load the app?",
    alreadyHaveAnCccount: "Do you already have an account?",
    forgotPassword: "Forgot your password?",
    newHere: "New here?",
    doYouWantToSendInvitation: "Do you want to send an invitation to access the company?",
    selectThisTreasuryAccountAsTheMainOne: "Select this treasury account as the main one?",
    youWantToDeleteThisTreasuryAccount: "Do you want to delete this treasury account?",
    youWantToSelectThisTreasuryAccountAsPrimary: "Do you want to select this treasury account as primary?",
    wantToExtendChangesToOtherCompanies: "Do you want to extend the changes to other companies?",
    youWantToDeleteThisContact: "Do you want to delete this contact?",
    youWantToDeleteSelectedContacts: "Do you want to delete the selected contacts?",
    youWantSendQuote: "Do you want to send the quote to the customer?",
    youWantToChangeQuoteStatusRejected: "Do you want to change the quote status to rejected?",
    youWantToGenerateAnOrderFromThisQuote: "Do you want to generate an order from this quote?",
    youWantToChangeStatusTheExpense: "Do you want to change the expense status?",
    youWantToDeleteThisDocument: "Do you want to delete this document?",
    youWantToRevertThisDocumentToDraft: "Do you want to revert this document to draft?",
    youWantToDeleteThisExpense: "Do you want to delete this expense?",
    youWantToChangeStatusTheProviderInvoice: "Do you want to change the provider invoice status?",
    youWantToGenerateAProviderInvoiceFromThisProviderOrder: "Do you want to generate a provider invoice from this provider order?",
    youWantToChangeOrderStatusToCanceled: "Do you want to change the order status to canceled?",
    youWantToGenerateAnInvoiceFromThisOrder: "Do you want to generate an invoice from this order?",
    youWantToSendTheOrderToCustomer: "Do you want to send the order to the customer?",
    youWantToCreateDeliveryNote: "Do you want to create a delivery note?",
    aFullDeliveryNoteWillBeCreated: "A full delivery note will be created for all items in this order",
    youWantToSendDeliveryNote: "Do you want to send this delivery note?",
    youWantToDeleteThisPayment: "Do you want to delete this payment?",
    youWantToChangeStatusTheInvoice: "Do you want to change the invoice status?",
    isCompanyOwnerOfBankAccount: "Is the company the owner of the bank account?",
    useReferenceWithinQR: "Use a reference within the QR?",
    youWantDeleteProduct: "Do you want to delete this product?",
    youWantDeleteSelectedProducts: "Do you want to delete the selected products?",
    youWantToDeleteThisReminder: "Do you want to delete this reminder?",
    youWantToDeleteThisCategory: "Do you want to delete this category?",
    youWantToDeleteTheStorageCenter: "Do you want to delete the storage center?",
    youWantToDeleteSelectedCategories: "Do you want to delete the selected categories?",
    youWantToDeleteTheStorageCenters: "Do you want to delete the storage centers?",
    youWantDeleteService: "Do you want to delete this service?",
    youWantDeleteSelectedServices: "Do you want to delete the selected services?",
    isCompanySubjectVat: "Is the company subject to VAT?",
    wouldYouLikeUploadPdfFilesToRegistrationNnewInvoice:
      "Would you like to upload one or more PDF files to facilitate the registration of a new invoice?",
    howWouldLikeDeclareVat: "How would you like to declare VAT?",
    youWantToDeleteThisPOS: "Do you want to delete this POS?",
    doYouWantJoinNewCompany: "Do you want to join the new company?",
    youWantToSendByEmail: "Do you want to send this document by email?",
    youWantToSendToCustomer: "Do you want to send this to the customer?",
    youWantToDeleteThisAddress: "Do you want to delete this address?",
    youWantToSetDefaultAddress: "Do you want to set this address as the default?",
    youWantToRejectQuote: "Do you want to reject this quote?",
    youWantToRejectOrder: "Do you want to reject this order?",

    // Exclamative sentences
    important: "Important!",
    exclamError: "Error!",
    networkError: "Network error",
    httpError: "HTTP error",
    yourSessionHasBeenClosed: "Your session has been closed, please sign in!",
    yourSessionHasExpired: "Your session has expired, please sign in again!",
    accountNotValidated: "Account not yet validated!",
    newRegisteredUser: "New registered user!",
    moneyBackGuarantee: "100% money-back guarantee!",
    somethingWentWrong: "Something went wrong!",
    thePageYouLookedNotFound: "The page you looked for was not found!",
    yourSessionIsActiveCongratulations: "Your session is active, congratulations!",
    weNeedYourAttention: "We need your attention!",
    yourAreDone: "You're done!",
    startCreatingNewTreasuryAccountsForYourCompany:
      "Start creating new treasury accounts for your company, it's very important for the app's functionality!",
    itNotChangeCompany: "It is not possible to change the company!",
    weAreWorkingFeature: "We're working on this feature. It will be available very soon!",
    processOfCreatingANewInvoiceCompleted: "Process of creating a new invoice completed!",
    processOfUpdatingAInvoiceCompleted: "Process of updating an invoice completed!",
    thereAreNoTreasuryAccounts: "There are no treasury accounts!",
    incorrectFiles: "Incorrect files!",
    startAddingNewElementsToThisCategory: "Start adding new elements to this category!",
    accountingAccountAlreadySelected: "Accounting account already selected, please select another!",
    servicesProductsWithTaxGreaterThanZero: "Services or products with tax greater than zero!",
    youHaveSuccessfullySignedOut: "You have successfully signed out!",
    selectContactViewTheirAccountStatement: "Select a contact to view their account statement!",
    processOfCreatingANewOrderCompleted: "Process of creating a new order completed!",
    processOfUpdatingAnOrderCompleted: "Process of updating an order completed",
    processOfCreatingQuoteCompleted: "Process of creating a new quote completed!",
    processOfCreatingAQuoteFromAnotherQuoteCompleted: "Process of creating a quote from another quote completed!",
    processOfCreatingAOrderFromAnotherOrderCompleted: "Process of creating an order from another order completed!",
    processOfCreatingAInvoiceFromAnotherInvoiceCompleted: "Process of creating an invoice from another invoice completed!",
    processOfUpdatingAQuoteCompleted: "Process of updating a quote completed!",
    processOfCreatingANewExpenseCompleted: "Process of creating a new expense completed!",
    processOfUpdatingAnExpenseCompleted: "Process of updating an expense completed!",
    processOfCreatingANewProviderInvoiceCompleted: "Process of creating a new provider invoice completed!",
    processOfUpdatingAProviderInvoiceCompleted: "Process of updating a provider invoice completed!",
    processOfCreatedAProviderOrderCompleted: "Process of creating a provider order completed!",
    processOfCreatedAProviderInvoiceCompleted: "Process of creating a provider invoice completed!",
    processOfCreatingANewProviderOrderCompleted: "Process of creating a new provider order completed!",
    processOfUpdatingAProviderOrderCompleted: "Process of updating a provider order completed!",
    successfullyCreatedAccountingAccount: "Successfully created accounting account!",
    successfullyCreatedCategory: "Successfully created category!",
    successfullyUpdatedCategory: "Successfully updated category!",
    successfullyInvitationSent: "Invitation sent successfully!",
    successfullyInvitationCancel: "Invitation canceled successfully!",
    successfullyCreatedContact: "Contact created successfully!",
    successfullyUpdatedContact: "Contact updated successfully!",
    successfullyCreatedReminder: "Reminder created successfully!",
    successfullyUpdatedStatus: "Status updated successfully!",
    successfullyUpdatedReminder: "Reminder updated successfully!",
    successfullyCreatedPayment: "Payment created successfully!",
    successfullyCreatedCompanyParameters: "Company parameters created successfully!",
    successfullyUpdatedTreasuryAccount: "Treasury account updated successfully!",
    successfullyAcceptedInvitation: "Invitation accepted successfully!",
    successfullyLoggedIn: "You have successfully logged in!",
    successfullyUpdatedCompanySettings: "Company settings updated successfully!",
    successfullyCreatedCompany: "Company created successfully!",
    successfullyDeletedPayment: "Payment deleted successfully!",
    successfullyCreatedInvoice: "Invoice created successfully!",
    successfullyDeletedReminder: "Reminder deleted successfully!",
    successfullyOrderSent: "Order sent successfully!",
    successfullyQuoteSent: "Quote sent successfully!",
    successfullyCreatedOrder: "Order created successfully!",
    successfullyCreatedDeliveryNote: "Delivery note created successfully!",
    successfullyDeliveryNoteSent: "Delivery note sent successfully!",
    successfullyCreatedTreasuryAccount: "Treasury account created successfully!",
    successfullyUpdatedDefaultTreasuryAccount: "Default treasury account updated successfully!",
    successfullyDeletedDocument: "Document deleted successfully!",
    successfullyDeletedTreasuryAccount: "Treasury account deleted successfully!",
    successfullyCreatedAccountingEntry: "Accounting entry created successfully!",
    successfullyUpdatedAccountingEntry: "Accounting entry updated successfully!",
    successfullyUpdatedBookingJournal: "Booking journal updated successfully!",
    successfulllyCreatedUser: "User created successfully!",
    successfullyCreatedStorageCenter: "Storage center created successfully!",
    successfullyUpdatedStorageCenter: "Storage center updated successfully!",
    successfullyCreatedStorageOperations: "Successfully created storage operations!",
    successfullyUpdatedPos: "Successfully created POS!",
    successfullyUpdatedUser: "Successfully updated user!",
    successfullyAddedAddress: "Address added successfully!",
    successfullyUpdatedAddress: "Address updated successfully!",
    successfullyDeletedAddress: "Address deleted successfully!",
    successfullySetDefaultAddress: "Default address set successfully!",
    successfullySentDocument: "Document sent successfully!",
    successfullyUpdated: "Successfully updated!",

    // Answer sentences
    okGotIt: "Ok, got it",
    yesLogOut: "Yes, log out",
    noCancel: "No, cancel",
    noContinue: "No, continue",
    yesDelete: "Yes, delete",
    yesResolveError: "Yes, resolve the error",
    yesSelect: "Yes, select",
    yesCanceled: "Yes, cancel",
    okClose: "Ok, close",
    yesReject: "Yes, reject",
    yesGenerate: "Yes, generate",
    yesSend: "Yes, send",
    yesChangeStatus: "Yes, change status",
    yesCreateTreasuryAccount: "Yes, create treasury account",
    yesValidate: "Yes, validate",
    yesInvalidate: "Yes, invalidate",
    yesUpload: "Yes, upload",
    noContinueForm: "No, continue with the form",
    yesAdd: "Yes, add",
    yesCreate: "Yes, create",
    yesConfirm: "Yes, confirm",

    // Suspensive sentences
    pleaseWait: "Please wait...",
    selectOption: "Select option...",
    searchContact: "Search contact...",
    searchCategory: "Search category...",
    searchProduct: "Search product...",
    searchService: "Search service...",
    searchStorage: "Search storage center...",
    searchBookingJournal: "Search booking journal...",
    searchAccountingAccount: "Search accounting account...",
    select: "Select...",
    search: "Search...",
    writeCommentToInvite: "Write a comment for the invitation...",
    loading: "Loading...",
    roles: "Roles",
    noRolesAvailable: "No roles available",
    noRolesDefinedForCompany: "No roles are defined for this company.",
    noAssignableRoles: "Your role does not allow you to assign any roles. Contact an administrator.",
    roleNotAssignableByYou: "Your role does not allow you to assign this role",
    roleAssignmentForbidden: "Your role does not allow assigning this role",
    subscriptionExpiredAction: "Your subscription has expired",
    system: "System",
    administration: "Administration",
    admin: "Admin",
    member: "Member",
    assignedRoles: "Assigned roles",
    assignRole: "Assign",
    removeRole: "Remove",
    manageRoles: "Manage roles",
    revoke: "Revoke",
    reinvite: "Re-invite",
    invite: "Invite",
    role: "Role",
    statusPending: "Pending",
    statusAccepted: "Accepted",
    statusRejected: "Rejected",
    statusExpired: "Expired",
    expiresAt: "Expires at",
    noMembers: "No members found",
    confirmRevoke: "Are you sure you want to revoke this invitation?",
    confirmRemoveRole: "Are you sure you want to remove this role?",
    policies: "Policies",
    createRole: "Create role",
    createPolicy: "Create policy",
    attachedPolicies: "Attached policies",
    attachPolicy: "Attach",
    detachPolicy: "Detach",
    statements: "Statements",
    addStatement: "Add statement",
    removeStatement: "Remove statement",
    effect: "Effect",
    allow: "Allow",
    deny: "Deny",
    actionsList: "Actions",
    resources: "Resources",
    resourcesHint: "Comma-separated resource identifiers, use * for all",
    noRoles: "No roles found",
    noPolicies: "No policies found",
    confirmDeleteRole: "Are you sure you want to delete this role?",
    confirmDeletePolicy: "Are you sure you want to delete this policy?",
    systemReadOnly: "This is a system element and cannot be modified",
    loadingCatalog: "Loading resource catalog...",
    emptyCatalog: "No resources available",
    advancedMode: "Advanced",
    preview: "Preview",

    // Abbreviated sentences
    n: "N°",
    mb: "MB",
    hrs: "hrs",
    min: "min",
    sec: "sec",

    // Enumeration
    first: "first",
    second: "second",
    third: "third",
    fourth: "fourth",
    fifth: "fifth",
    sixth: "sixth",

    // Languages
    english: "English",
    french: "French",
    italian: "Italian",
    german: "German",
    spanish: "Spanish",

    // Months
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",

    // Periods
    monthly: "Monthly",
    quarterly: "Quarterly",
    semiannual: "Semiannual",
    annual: "Annual",
    createAccount: "Create account",
    createSiblingAccount: "Create sibling account",
    createChildAccount: "Create sub-account",
    siblingOf: "Sibling of",
    subAccountOf: "Sub-account of",
    nameFr: "Name (French)",
    nameEn: "Name (English)",
    nameDe: "Name (German)",
    nameIt: "Name (Italian)",
    codeAndNameFrRequired: "Code and French name are required",
    accountCreatedSuccessfully: "Account created successfully",
    renameAccount: "Rename account",
    accountRenamedSuccessfully: "Account renamed successfully",
    siblingCodeHint: "4 digits — e.g. 1005",
    childCodeHint: "XXXX.N — e.g. 1000.01",
    siblingAccount: "Sibling account",
    subAccount: "Sub-account",
    referenceAccount: "Reference account",
    creationMode: "Creation mode",
    foreignCurrency: "Foreign currency",
    enableForeignCurrency: "Invoice in foreign currency",
    exchangeRate: "Exchange rate",
    exchangeDate: "Rate date",
    foreignCurrencyPreview: "Converted amount preview",
    convertedTotal: "Converted total",
    rateInfo: "Exchange rate info",
    amountInCurrency: "Amount in {currency}",
    amountInCHF: "Amount CHF",
    partialBalance: "Partial (no conversion)",
    approxBalanceTooltip: "Line(s) without exchange rate — {currency} balance approximate",
    partialLinesFooter: "partial ({count} lines without rate)",
    currencyColumn: "Currency",
    vatPeriodicity: "VAT periodicity",
    firstPeriod: "First period",
    deductionMethod: "Deduction method",
    methodInvoicing: "Based on invoicing",
    methodCashing: "Based on cashing",
    periodConfigured: "Fiscal periods configured",
    periodOpen: "Open",
    periodClosed: "Closed",
    periodFiled: "Filed",
    closePeriod: "Close period",
    taxSettingsLocked: "Tax settings are locked because a fiscal period has been created. To modify them, contact your fiduciary.",
    taxSettingsLockedContact: "If you wish to change the VAT regime, you need to contact",
    period: "Period",
    format: "Format",
    reconciliation: "Reconciliation",
    bankStatements: "Bank statements",
    importStatement: "Import statement",
    importBankStatement: "Import bank statement",
    allTreasuryAccounts: "All treasury accounts",
    statementDate: "Statement date",
    openingBalance: "Opening balance",
    closingBalance: "Closing balance",
    importFailed: "Import failed",
    dragAndDropOrClick: "Drag & drop a file here, or click to select",
    importing: "Importing...",
    importAction: "Import",
    autoMatchInfo: "After import, an automatic reconciliation will be launched to match transactions with existing invoices.",
    importSourceStructured: "Structured file (CAMT/CSV)",
    importSourcePdfUpload: "PDF — upload",
    importSourcePdfExisting: "PDF — existing document",
    extractingStatement: "Extracting statement...",
    preparingDocument: "Preparing document...",
    extractionFailed: "Extraction failed. Please try again.",
    selectExistingDocument: "Select an existing document",
    noPdfDocumentsAvailable: "No PDF documents available",
    retryExtraction: "Retry extraction",
    extractionTimeout: "Extraction is taking longer than expected. Please try again later.",
    jobQueued: "Queued...",
    jobFailed: "Failed",
    heuristicSuggestions: "Heuristic suggestions",
    unmatchedLines: "Unmatched lines",
    bankTransactions: "Transactions",
    oneStatementNeedingAttention: "1 statement needs attention",
    statementsNeedingAttention: "statements need attention",
    someTransactionsNotReconciled: "Some transactions are not yet reconciled",
    continueReconciliation: "Continue reconciliation",
    finishReconciliation: "Finish reconciliation",
    counterpartIban: "Counterpart IBAN",
    matchedVia: "Match method",
    noTransactionsFound: "No transactions found",
    viewStatement: "View statement",
    alreadyImported: "Already imported",
    overlapWarning: "This period overlaps {n} already imported statement(s) for this account.",
    duplicatesUnchecked: "{x} already present transaction(s) unchecked automatically.",
    includeLine: "Include",
    confirmed: "Confirmed",
    sortByPeriod: "Sort by period",
    confirmDeleteStatement: "Delete draft statement?",
    confirmDeleteStatementText: "This draft statement and its associated document will be permanently deleted. This action cannot be undone.",
    existingPayments: "Existing payments",
    linkThisPayment: "Link this payment",
    link: "Link",
    autoMatchAll: "Auto-reconcile",
    exportTransactions: "Export transactions",
    reconcile: "Reconcile",
    reconcileAutomatically: "Reconcile automatically",
    paid: "Paid",
    entry: "Entry",
    documentsToValidate: "Documents to validate",
    validateAndReconcile: "Validate & reconcile",
    toValidate: "To validate",
    dateFrom: "From",
    dateTo: "To",
    resetFilters: "Reset",
    transactions: "transactions",
    previous: "Previous",
    next: "Next",
    matched: "Matched",
    ignored: "Ignored",
    relaunchAutoMatch: "Re-run auto reconciliation",
    matching: "Reconciling",
    starting: "Starting",
    jobRunning: "Auto reconciliation running",
    linesProcessed: "Lines processed",
    noLinesPending: "No pending lines",
    matchManually: "Reconcile manually",
    match: "Reconcile",
    unmatch: "Undo reconciliation",
    ignore: "Ignore",
    noLinesInStatement: "No lines in this statement",
    statementNotFound: "Statement not found",
    confirmUnmatch: "Undo reconciliation for this line?",
    unmatchWillDeleteEntry: "The associated accounting entry may be deleted.",
    yesUnmatch: "Yes, undo",
    confirmIgnore: "Ignore this line?",
    yesIgnore: "Yes, ignore",
    restoreLine: "Restore",
    lineRestored: "Line restored to pending.",
    saveDraft: "Save",
    draftSaved: "Draft saved.",
    savingDraft: "Saving…",
    unsavedChanges: "Unsaved changes",
    unsavedChangesBody: "You have unsaved changes. What would you like to do?",
    quitWithoutSaving: "Quit without saving",
    statementNotDraft: "This statement is no longer a draft. Reloading…",
    jobAlreadyRunning: "Auto reconciliation is already running",
    noCandidatesFound: "No candidates found",
    reconcileAndCollect: "Reconcile & collect",
    partialCollection: "partial collection",
    score: "Score",
    pending: "Pending",
    deleteStatement: "Delete statement",
    confirmDeleteStatementTitle: "Delete this bank statement?",
    confirmDeleteStatementBody: "This action deletes the statement and its {count} unreconciled transaction(s).",
    statementDeleted: "Statement deleted successfully.",
    cannotDeleteMatchedLines: "Cannot delete: {count} reconciled transaction(s). Unlink reconciliations first.",
    cannotDeleteMatchedLinesTooltip: "Cannot delete: {count} reconciled transaction(s). Unlink reconciliations first.",
    statementHasMatchedLinesError: "This statement has {count} reconciled transaction(s). Unlink them before deleting.",
    invalidateStatement: "Invalidate",
    confirmInvalidateStatementTitle: "Invalidate this bank statement?",
    confirmInvalidateStatementBody: "The statement will revert to draft for correction. Its {count} transaction(s) will no longer be available for reconciliation. The imported document remains attached.",
    statementInvalidated: "Statement reverted to draft.",
    confirmInvalidate: "Yes, invalidate",

    // VAT Return
    vatReturn: "VAT return",
    vatSectionTurnover: "I. Turnover",
    vatSectionTaxCalculation: "II. Tax calculation",
    vatSectionOtherFlows: "III. Other cash flows",
    vatTaxDue: "Tax due",
    vatInputTax: "Input tax",
    vatBalance: "Balance in favour of FTA / taxable person",
    vatTax: "Tax",
    vatCaseComposition: "Case composition",
    vatCounterServices: "Counter-services",
    vatDeductions: "Deductions",
    vatTaxableTurnover: "Taxable turnover",
    vatAmountToPayAFC: "Amount payable to the FTA",
    vatBalanceInFavor: "Credit in favour of the taxable person",
    vatTotalDeductions: "Total deductions",
    vatTotalTaxDue: "Total tax due",
    vatTotalInputTax: "Total input tax",
    vatNormalRate: "Services subject to normal rate",
    vatReducedRate: "Services subject to reduced rate",
    vatAccommodationRate: "Services subject to accommodation rate",
    vatAcquisitions: "Acquisition tax (net, excl. VAT)",
    caseNumber: "Case",
    base: "Base",
    sign: "Sign",
    nature: "Nature",
    reference: "Reference",
    back: "Back",
    accountingDocument: "Accounting document",
    documentNumber: "Document number",
    entryNumber: "Entry number",
    entryNumberShort: "No.",
    manualEntry: "Manual entry",
    createAndReconcile: "Create & reconcile",
    gap: "Gap",
    editVatAdjustment: "Edit VAT adjustment",
    noteOptional: "Note (optional)",
    vouchersSoonAvailable: "Vouchers (coming soon)",
    periodIsFiledCannotEdit: "This period is filed. Adjustments cannot be modified.",
    csvImport: "CSV import",
    difference: "Difference",
    balanced: "Balanced",
    unbalanced: "Unbalanced",
    saveOpeningBalance: "Save opening balance",
    forceReprise: "Force opening balance",
    forceRepriseWarning: "The previous fiscal year is closed. Forcing will overwrite the automatic opening entry. Are you sure?",
    csvFormatHelp: "Accepted CSV formats (semicolon separator):",
    csvFormatBHelp: "1000;15000 (positive = debit, negative = credit)",
    closedFiscalYearReadonly: "This fiscal year is closed. The opening balance cannot be modified.",
    deleteOpeningBalance: "Delete opening balance",
    confirmDeleteOpeningBalance: "Are you sure you want to delete the opening balance? All amounts will be reset.",
    amountMustBePositive: "Amount must be positive — use the debit or credit column.",

    // Period status transitions
    filePeriod: "File",
    reopenPeriod: "Reopen",
    confirmClosePeriod: "Are you sure you want to close this period? Entries will no longer be editable until the period is reopened.",
    confirmFilePeriod: "Are you sure you want to file this period? This action is permanent and cannot be undone.",
    confirmFilePeriodWarning: "Once filed, the VAT return will be frozen and no modification will be possible.",
    confirmReopenPeriod: "Are you sure you want to reopen this period? Entries will become editable again.",

    // Fiscal Years
    fiscalYears: "Fiscal years",
    fiscalYear: "Fiscal year",
    newFiscalYear: "New fiscal year",
    closeFiscalYear: "Close fiscal year",
    closeFiscalYearConfirm: "Are you sure you want to close this fiscal year? This action is irreversible. All entries will be locked and no further modifications will be possible.",
    closeFiscalYearWarning: "This action is irreversible. Once closed, no entry can be added or modified for this fiscal year.",
    reopenFiscalYear: "Reopen fiscal year",
    reopenFiscalYearConfirm: "Are you sure you want to reopen this fiscal year?",
    reopenFiscalYearWarning: "The closing entry, the opening balance carry-forward and the result allocation of the following fiscal year will be deleted. The periods will be reopened. You will be able to close the year again afterwards.",
    reopenFiscalYearFirstReopen: "Reopen fiscal year {name} first",
    noFiscalYears: "No fiscal years found",
    createFiscalYear: "Create fiscal year",
    editFiscalYear: "Edit fiscal year",
    deleteFiscalYear: "Delete fiscal year",
    confirmDeleteFiscalYear: "Are you sure you want to permanently delete this fiscal year? This action cannot be undone.",
    fiscalYearStartDate: "Fiscal year start date",
    fiscalYearClosingYear: "Closing year",
    fiscalYearEndDate: "Fiscal year end date",
    fiscalYearEndForced: "The fiscal year always ends on December 31",
    accountingSettingsInitializing: "Initialization in progress…",

    // Annual correction
    annualCorrection: "Annual correction",
    createAnnualCorrection: "Create annual correction",
    viewAnnualCorrection: "View annual correction",
    confirmCreateAnnualCorrection: "Create the annual correction for this fiscal year? Orphan tickets will be swept into a new correction period.",
    periodsNotAllFiled: "All periods must be filed before creating the annual correction.",
    noOrphans: "No orphan tickets to correct for this fiscal year.",
    ticketsPending: "tickets pending",

    // Vouchers
    confirmDeleteVoucher: "Are you sure you want to remove this voucher?",
    pendingUpload: "pending",
    uploadFailed: "Upload failed for one or more files. The amount and note have been saved.",
    addVoucher: "Add voucher",

    // Manual entries
    vatInputType: "Input tax type",
    vatInputGoods: "Goods and materials",
    vatInputInvestment: "Investments and other expenses",
    deleteAccountingEntry: "Delete entry",
    confirmDeleteAccountingEntry: "Are you sure you want to delete this entry?",

    // Financial statements
    balanceSheet: "Balance sheet",
    incomeStatement: "Income statement",
    trialBalance: "Trial balance",
    assets: "Assets",
    liabilities: "Liabilities",
    revenue: "Revenue",
    netResult: "Net result",
    asOfDate: "As of",
    previousYear: "Previous year",
    variation: "Variation",
    notBalanced: "Not balanced",
    sortByCode: "Sort by account",
    sortByBalance: "Sort by balance",
    allLevels: "All levels",
    profitOfYear: "Profit for the year",
    lossOfYear: "Loss for the year",
    viewList: "List",
    viewColumns: "Side by side",
    totalLiabilitiesAndResult: "Total liabilities & result",
    viewVouchers: "View vouchers",
    pendingDocuments: "pending document(s)",
    showZeroAccounts: "Show zero-balance accounts",
    hideZeroAccounts: "Hide zero-balance accounts",
    chatTitle: "Chat",
    chatConversations: "Conversations",
    chatNewConversation: "New conversation",
    chatNoConversations: "No conversations yet",
    chatNoMessages: "No messages yet. Say hello!",
    chatPlaceholder: "Type a message...",
    chatSend: "Send",
    chatYou: "You",
    chatBack: "Back",
    chatStartConversation: "Chat",
    chatSelectMember: "Select a member",
    chatLoadingMembers: "Loading members...",
    chatNoMembers: "No members found",
    chatLoadingMessages: "Loading messages...",
    chatActive: "Active",
    featureLabelContacts: "Contacts & CRM",
    featureLabelSaleCore: "Sales & invoicing",
    featureLabelPurchaseCore: "Purchases & supplier invoices",
    featureLabelTreasuryPayments: "Payments & bank reconciliation",
    featureLabelCatalog: "Product & service catalog",
    featureLabelAccountingCore: "Accounting",
    featureLabelArchiveOcr: "Document archive & OCR",
    featureLabelNetworkInterbilling: "Inter-company billing",
    featureLabelPaymentOnline: "Online payments",
    featureLabelDunning: "Dunning & reminders",
    featureLabelSaleRecurring: "Recurring invoicing",
    featureLabelTreasuryEbanking: "E-banking connection",
    featureLabelTreasuryForecast: "Cash flow forecast",
    featureLabelProjectsTime: "Projects & time tracking",
    featureLabelPos: "Point of sale",
    featureLabelExpenses: "Expense reports",
    featureLabelInventory: "Inventory management",
    featureLabelSaleConsignment: "Consignment sales",
    featureLabelAccountingAssets: "Fixed asset management",
    featureLabelServiceRepair: "Service & repair tracking",
    featureLabelRbacAdvanced: "Advanced access control",
    featureLabelMultiCompany: "Multi-company",
    featureLabelPayroll: "Payroll",
    featureLabelStorefront: "Online storefront",
    featureLabelEsignature: "Electronic signature",
    featureLabelMobileSale: "Mobile sales app",
    featureLabelMobileExpenses: "Mobile expense capture",
    featureLabelSupportPriority: "Priority support",
    searchDocuments: "Search documents",
    searchDocumentsPlaceholder: "Search documents (name, OCR content)...",
    searchingDocuments: "Searching...",
    searchDocumentsResultsCount: "{{count}} result(s) for \"{{query}}\"",
    searchDocumentsNoResults: "No results for \"{{query}}\"",
    filterDocumentStatus: "Document status",
    filterDocumentDateFrom: "Document date from",
    filterDocumentDateTo: "Document date to",
    filterUploadDateFrom: "Upload date from",
    filterUploadDateTo: "Upload date to",
    statementToValidate: "Statement to validate",
    draftMode: "Draft mode",
    confirmImport: "Confirm import",
    extractedByVision: "Extracted by image analysis",
    extractedByText: "Extracted by text",
    reconciliationGapWarning: "Gap of {gap} — check lines",
    confirmUnbalancedTitle: "Unbalanced statement",
    confirmUnbalancedText: "The statement is not balanced. Confirm anyway?",
    ocrStatus: "OCR status",
    uploadedAt: "Uploaded on",
    pageXofN: "Page {page} of {pages}",
    filterByStatus: "Filter by status",
    allStatuses: "All",
    statusNew: "New",
    statusAssigned: "Assigned",
    statusPartiallyProcessed: "Partially processed",
    statusProcessed: "Processed",
    createFullInvoice: "Full invoice",
    depositInvoice: "Deposit invoice",
    partialInvoice: "Partial invoice",
    depositAmount: "Deposit amount",
    depositDescription: "Description",
    quantityToInvoice: "Quantity to invoice",
    remainingQuantity: "Remaining",
    invoicedQuantity: "Invoiced",
    totalQuantity: "Total",
    notInvoiced: "Not invoiced",
    partiallyInvoiced: "Partially invoiced",
    fullyInvoiced: "Fully invoiced",
    invoicingStatus: "Invoicing status",
    invoicedAmountOf: "invoiced of",
    linkedInvoices: "Linked invoices",
    noInvoicesYet: "No invoices yet",
    youWantToCreateDepositInvoice: "Do you want to create a deposit invoice?",
    youWantToCreatePartialInvoice: "Do you want to create a partial invoice?",
    noLinesToInvoice: "No lines to invoice",
    depositAmountExceedsRemaining: "The amount exceeds the remaining balance",
    manageStock: "Manage stock",
    stockManagedDescription: "Each sale will automatically decrement the stock from the storage center.",
    stockDisabledDescription: "No stock movements will be generated for sales from this cashier.",
    stockManaged: "Stock managed",
    withoutStockManagement: "Without stock management",
    recipient: "Recipient",
    emailSubject: "Subject",
    emailMessage: "Message",
    emailSent: "Email sent successfully",
    emailDefaultMessage: "Please find attached the document mentioned in the subject.",
    correctAccounts: "Correct accounts",
    saveCorrection: "Save correction",
    correctingAccountsDescription: "You can correct the counterpart accounts of this document. The accounting entry will be updated in place.",
    successfullyCorrectedAccounts: "Accounts corrected successfully",

    // Payroll
    payroll: "Payroll",
    payrollShort: "Payroll",
    employees: "Employees",
    addEmployee: "Add employee",
    editEmployee: "Edit employee",
    employeeNumber: "Employee number",
    searchEmployee: "Search employee...",
    noEmployeesFound: "No employees found",
    employeeStatusActive: "Active",
    employeeStatusDraft: "Draft",
    employeeStatusTerminated: "Terminated",
    workCanton: "Work canton",
    activityRate: "Activity rate",
    employmentContract: "Employment contract",
    avsNumber: "AVS number",
    residencePermit: "Residence permit",
    backToList: "Back to list",
    backToDashboard: "Back to dashboard",
    featureComingSoon: "This feature is coming soon.",
    payrollAccessDenied: "Access denied",
    payrollAccessDeniedOwnerOnly: "Payroll is restricted to company owners. Please contact your administrator if you believe you should have access.",
    payrollAccessDeniedReconnect: "If your permissions were recently updated, please log out and log back in to refresh your session.",

    // Payroll forms
    identity: "Identity",
    birthDate: "Date of birth",
    gender: "Gender",
    gender_male: "Male",
    gender_female: "Female",
    civilStatus: "Civil status",
    civilStatus_single: "Single",
    civilStatus_married: "Married",
    civilStatus_divorced: "Divorced",
    civilStatus_widowed: "Widowed",
    civilStatus_registered_partnership: "Registered partnership",
    civilStatus_dissolved_partnership: "Dissolved partnership",
    civilStatusSince: "Civil status since",
    civilStatusSinceHelp: "Determines the applicable withholding tax scale. A change of civil status takes effect the month following the event.",
    nationality: "Nationality",
    permitType: "Permit type",
    permitNumber: "Permit number",
    permitValidUntil: "Valid until",
    issuingCanton: "Issuing canton",
    swissNational: "Swiss national",
    permit: "Permit",
    residence: "Residence",
    canton: "Canton",
    municipality: "Municipality",
    familySituation: "Family situation",
    hasSpouse: "Has spouse / registered partner",
    spouseIsWorking: "Spouse is working",
    spouseWorkCanton: "Spouse work canton",
    spouseWorkCountry: "Spouse work country",
    children: "Children",
    addChild: "Add child",
    child: "Child",
    allowanceFrom: "Allowance from",
    allowanceTo: "Allowance to",
    inEducation: "In education",
    paymentDetails: "Payment details",
    bic: "BIC/SWIFT",
    accountHolder: "Account holder",
    notes: "Notes",
    linkedContact: "Linked contact",
    searchContact: "Search for an existing contact...",
    contactRequired: "Please select a contact",
    refreshSnapshot: "Refresh contact data",
    change: "Change",

    // Contract form
    contractHistory: "Contract history",
    addContractVersion: "Add contract version",
    newContractVersion: "New contract version",
    editContract: "Edit contract",
    newVersionWarning: "This will create version {version} of the contract, effective from the date you set. Version {prevVersion} will be closed automatically.",
    contractType: "Contract type",
    contractType_permanent: "Permanent",
    contractType_fixed_term: "Fixed term",
    contractType_apprenticeship: "Apprenticeship",
    contractType_internship: "Internship",
    salaryMode: "Salary mode",
    salaryMode_monthly: "Monthly",
    salaryMode_hourly: "Hourly",
    hireDate: "Hire date",
    endReason: "End reason",
    weeklyHours: "Weekly hours",
    probationMonths: "Probation (months)",
    noticePeriod: "Notice period (months)",
    salary: "Salary",
    baseSalary: "Base salary",
    thirteenthSalary: "13th salary",
    thirteenthMode: "Payment mode",
    thirteenthMode_december: "December",
    thirteenthMode_monthly_provision: "Monthly provision",
    thirteenthModeHelp: "December — the 13th salary is paid in full in December. If the employee leaves during the year, the accrued portion is paid in the final settlement.\n\nMonthly provision — one twelfth is paid each month with the regular payroll. No payment in December.",
    vacation: "Vacation",
    vacationDays: "Days per year",
    vacationRate: "Vacation rate (%)",
    workplace: "Workplace",
    workplaceAddressCompany: "Company address",
    workplaceAddressOther: "Other address",
    validFrom: "Effective from",
    validTo: "Until",
    version: "Version",
    current: "Current",
    closed: "Closed",
    future: "Future",
    noContracts: "No contracts yet",
    // Contract termination
    terminateContract: "Terminate contract",
    confirmTermination: "Confirm termination",
    terminationConsequences: "Terminating this contract will have the following effects:",
    terminationStatusChange: "The employee status will change to <strong>terminated</strong>",
    terminationFinalSettlement: "A <strong>final settlement</strong> will be produced on the payroll period containing this date",
    terminationExclusion: "The employee will be <strong>excluded from subsequent payroll runs</strong>, except for retroactive adjustments",
    terminationWarning: "Terminating a contract triggers a final settlement on the payroll period containing the end date. This action can be cancelled before the payroll run is validated.",
    contractTerminated: "Contract terminated",
    cancelTermination: "Cancel termination",
    cancelTerminationConfirm: "Are you sure you want to cancel this termination? The employee will be set back to active status.",
    terminationCancelled: "Termination cancelled",
    terminated: "Terminated",
    endReason_resignation: "Resignation",
    endReason_dismissal: "Dismissal",
    endReason_mutual_agreement: "Mutual agreement",
    endReason_end_of_term: "End of term",
    endReason_retirement: "Retirement",
    endReason_death: "Death",
    endReason_disability: "Disability",
    endReason_probation: "End of probation",

    // Payroll — Company salary settings
    salarySettings: "Salary settings",
    insurancePlans: "Insurance plans",
    payrollSettings: "Payroll settings",
    payrollCompleteness: "Payroll readiness",
    payrollCompletenessOk: "All required settings are configured. Payroll can be calculated.",
    payrollCompletenessMissing: "The following settings must be completed before payroll can be calculated:",
    insurancePlanType_laap: "LAA Professional (LAAP)",
    insurancePlanType_laanp: "LAA Non-professional (LAANP)",
    insurancePlanType_laac: "LAA Complementary (LAAC)",
    insurancePlanType_ijm: "Daily sickness insurance (IJM)",
    insurancePlanType_lpp: "Occupational pension (LPP)",
    insurerName: "Insurer name",
    policyNumber: "Policy number",
    rateEmployee: "Employee rate (%)",
    rateEmployer: "Employer rate (%)",
    riskClass: "Risk class",
    lppRatesByAge: "Rates by age bracket",
    lppAgeFrom: "From age",
    lppAgeTo: "To age",
    addAgeBracket: "Add age bracket",
    coordinationDeductionOverride: "Coordination deduction override",
    entryThresholdOverride: "Entry threshold override",
    addInsurancePlan: "Add insurance plan",
    editInsurancePlan: "Edit insurance plan",
    noInsurancePlans: "No insurance plans yet",
    effectiveSince: "Effective since {date}",
    closurePlanWarning: "This plan will take effect on {date}. The current {type} plan will be closed on {closureDate}.",
    confirmDeletePlan: "Are you sure you want to delete this insurance plan?",
    deletePlan: "Delete plan",
    avsFund: "AVS fund",
    avsFundName: "Fund name",
    avsMemberNumber: "Member number",
    avsAdministrationRate: "Administration rate (%)",
    familyAllowanceFund: "Family allowance fund",
    familyAllowanceFundName: "Fund name",
    familyAllowanceMemberNumber: "Member number",
    withholdingTax: "Withholding tax",
    withholdingTaxCanton: "Tax canton",
    withholdingTaxDebtorNumber: "Debtor number",
    withholdingTaxPeriodicity: "Declaration periodicity",
    periodicityMonthly: "Monthly",
    periodicityQuarterly: "Quarterly",
    periodicityAnnual: "Annual",
    payFrequency: "Pay frequency",
    payFrequencyMonthly: "Monthly",
    payFrequencySemiMonthly: "Semi-monthly",
    payFrequencyWeekly: "Weekly",
    missingActiveLaap: "Active LAAP plan with employer rate",
    missingActiveLaanp: "Active LAANP plan with employee rate",
    missingActiveLpp: "Active LPP plan with age brackets",
    missingAvsFundName: "AVS fund name",
    missingAvsAdminRate: "AVS administration rate",
    missingFamilyAllowanceFundName: "Family allowance fund name",
    missingAvsAdminBase: "AVS administration fee calculation base",
    missingFamilyAllowanceRate: "Family allowance contribution rate",
    administrationBase: "Administration fee base",
    administrationBaseAvsContributions: "AVS/AI/APG contributions",
    administrationBaseGrossAvs: "Gross salary subject to AVS",
    administrationBaseHelp: "Depending on your fund, the rate applies either to the total AVS/AI/APG contributions or to the gross salary subject to AVS. This information is on your fund statement.",
    familyAllowanceContributionRate: "Employer contribution rate",
    familyAllowanceRateHelp: "This rate depends on your affiliation fund, not the canton. Two companies in the same canton affiliated to different funds may pay different rates.",
    expenseRegulation: "Expense regulation",
    expenseRegulationApproved: "Approved expense regulation",
    expenseRegulationCanton: "Approval canton",
    expenseRegulationDate: "Approval date",
    expenseRegulationReference: "Reference number",
    withholdingTaxNote: "Withholding tax configuration is partial. Full support (barème lookup, annual corrections) is planned for a future release.",
    showPlanHistory: "Show history",
    hidePlanHistory: "Hide history",

    // Payroll — Payroll runs
    payrollRuns: "Payroll runs",
    payrollRun: "Payroll run",
    payslip: "Payslip",
    payslips: "Payslips",
    openPeriod: "Open period",
    period: "Period",
    employeeCount: "Employees",
    grossTotal: "Gross",
    netTotal: "Net",
    employerCost: "Employer cost",
    totalDeductions: "Deductions",
    totalEmployerCharges: "Employer charges",
    validatedAt: "Validated on",
    calculate: "Calculate",
    recalculate: "Recalculate",
    validate: "Validate",
    markAsPaid: "Mark as paid",
    cancelRun: "Cancel",
    regeneratePdfs: "Regenerate PDFs",
    downloadSummary: "Download summary",
    downloadPayslip: "Download payslip",
    calculating: "Calculating...",
    calculatingProgress: "Calculation in progress. This may take a few minutes.",
    calculatingTimeout: "The calculation is taking longer than expected. You may retry.",
    retryCalculation: "Retry calculation",
    noPayrollRuns: "No payroll runs yet",
    noPayslips: "No payslips",
    createPayrollRun: "Open a payroll period",
    periodAlreadyExists: "A payroll run already exists for this period.",
    periodAlreadyExistsLink: "View existing run",
    confirmValidateTitle: "Validate payroll run",
    confirmValidateBody: "{count} payslips — Gross: {gross} — Net: {net} — Employer cost: {employerCost}",
    confirmValidateIrreversible: "This action is irreversible. Payslips will be frozen and PDFs generated. Any correction will require a cancellation or a retroactive adjustment.",
    confirmValidateFinalSettlements: "This run contains {count} final settlement(s).",
    confirmValidateNegativeNets: "This run contains {count} payslip(s) with a negative net.",
    confirmCancelTitle: "Cancel payroll run",
    cancellationReason: "Cancellation reason",
    cancellationReasonRequired: "A reason is required to cancel a payroll run.",
    confirmPayTitle: "Mark as paid",
    confirmPayBody: "Confirm that {count} payslips totalling {net} net have been paid.",
    payslipProvisional: "Provisional — not yet validated",
    provisional: "Provisional",
    interim: "Interim",
    ancillaryActivities: "Ancillary Activities",
    extraordinaryItems: "Extraordinary Items",
    payslipFailed: "Calculation failed",
    controlPanel: "Control panel",
    failedPayslips: "Failed payslips",
    failedPayslipsBlocking: "Validation is blocked: {count} payslip(s) failed to calculate.",
    excludedEmployees: "Excluded employees",
    runWarnings: "Warnings",
    finalSettlements: "Final settlements",
    negativeNets: "Negative nets",
    retroactiveOnly: "Retroactive only",
    runStatusDraft: "Draft",
    runStatusCalculating: "Calculating",
    runStatusCalculated: "Calculated",
    runStatusValidated: "Validated",
    runStatusPaid: "Paid",
    runStatusCancelled: "Cancelled",
    exclusionStatusDraft: "Employee in draft status",
    exclusionStatusTerminated: "Employment terminated",
    exclusionNoContract: "No active contract",
    exclusionHireAfterPeriod: "Hired after the period",
    exclusionContractEndedBeforePeriod: "Contract ended before the period",
    warningLppNotVerifiableHourly: "LPP contributions could not be verified for hourly employees",
    warningPdfGenerationFailed: "PDF generation failed for this payslip",
    warningHasAbsence: "This employee has absences during the period",
    warningHourlyAbsenceNotDeducted: "Hourly employee with absences — deduction is not applied automatically",
    warningHourlyZeroGross: "Hourly employee with zero gross salary",

    // Monthly declaration
    monthlyDeclaration: "Monthly declaration",
    monthlyDeclarations: "Monthly declarations",
    socialInsuranceDays: "SI days",
    absenceDays: "Absence days",
    effectiveWorkingDays: "Effective working days",
    workingHours: "Hours",
    absences: "Absences",
    addAbsence: "Add absence",
    editAbsence: "Edit absence",
    deleteAbsence: "Delete absence",
    absenceOngoing: "Ongoing",
    daysRetained: "{days} day(s) retained",
    declarationValidated: "Validated",
    declarationDraft: "Draft",
    validateDeclaration: "Validate declaration",
    validateAllDeclarations: "Validate all",
    saveDeclaration: "Save",
    noEligibleEmployees: "No eligible employees for this run",
    hourlyNoHoursWarning: "Hourly employee with no hours entered — payslip will be zero",
    declarationNotValidated: "Declaration not validated",
    recalculationNeeded: "Payroll variables have been modified since the last calculation. Recalculation is needed before validation.",
    loadError: "Failed to load data",
    retry: "Retry",
    punctualRubriques: "One-time items",
    addRubrique: "Add item",
    removeRubrique: "Remove",
    rubriqueCode: "Code",
    rubriqueLabel: "Label",
    rubriqueAmount: "Amount",
    rubriqueQuantity: "Quantity",
    rubriqueRate: "Rate",
    rubriqueCalculationMode: "Calculation mode",
    declarationFor: "Declaration for {name}",
    backToRun: "Back to run",
    editDeclaration: "Edit variables",
    activityRate: "Activity rate",
    noRubriques: "No punctual rubriques",
    saveAndClose: "Save and close",

    // Absence reasons
    absenceReason: "Absence reason",
    absenceReasonIllness: "Illness",
    absenceReasonAccidentOccupational: "Occupational accident",
    absenceReasonAccidentNonOccupational: "Non-occupational accident",
    absenceReasonMilitaryService: "Military service",
    absenceReasonMaternity: "Maternity",
    absenceReasonPaternity: "Paternity",
    absenceReasonUnpaid: "Unpaid absence",
    absenceReasonUnjustified: "Unjustified absence",
    incapacityRate: "Incapacity rate",
    salaryContinuationRate: "Salary continuation",
    absenceFrom: "From",
    absenceTo: "To",
    absenceToHelp: "Leave empty if absence is ongoing",
    confirmDeleteAbsence: "Are you sure you want to delete this absence?",

    // Absence report
    absenceReport: "Absence report",
    absenceHistory: "Absence history",
    totalByReason: "Total by reason",
    noAbsences: "No absences",
    filterByYear: "Filter by year",
    filterByReason: "Filter by reason",
    allReasons: "All reasons",
    goToPayrollRun: "View payroll run",
    companySnapshotIncomplete: "Company data is incomplete (name, address, or IDE number missing). Payslip PDFs may be affected.",
    companySettings: "Go to company settings",
    validateBlockedByFailures: "Cannot validate: there are failed payslips",
    backToPayrollRuns: "Back to payroll runs",
    year: "Year",

    // Zod error map
    zodFieldRequired: "This field is required",
    zodInvalidType: "Invalid value",
    zodTooShort: "Minimum {min} characters",
    zodTooLong: "Maximum {max} characters",
    zodNumberTooSmall: "Must be at least {min}",
    zodNumberTooBig: "Must be at most {max}",
    zodArrayTooShort: "At least {min} item(s) required",
    zodInvalidEmail: "Invalid email address",
    zodInvalidFormat: "Invalid format",
    zodInvalidSelection: "Please select a valid option",
    zodInvalidDate: "Invalid date",
    zodInvalidValue: "Invalid value",

    // Reconciliation indicators
    reconciled: "Reconciled",
    notReconciled: "Not reconciled",
    filteredTotalsWarning: "Totals reflect the current filter, not the full account",

    // Recurring contracts
    recurringContracts: "Recurring contracts",
    recurringContract: "Recurring contract",
    addRecurringContract: "Add recurring contract",
    createRecurringContract: "Create recurring contract",
    updateRecurringContract: "Update recurring contract",
    viewRecurringContract: "Recurring contract details",
    searchRecurringContract: "Search contract...",
    allStatuses: "All statuses",
    frequency: "Frequency",
    monthly: "Monthly",
    quarterly: "Quarterly",
    semiAnnual: "Semi-annual",
    annual: "Annual",
    nextInvoiceDate: "Next invoice",
    generateInvoice: "Generate invoice",
    generateInvoiceConfirm: "An invoice will be created from this contract.",
    invoiceGenerated: "Invoice generated",
    generatedInvoices: "Generated invoices",
    pause: "Pause",
    paused: "Paused",
    activate: "Activate",
    changeStatusTo: "Change status to",
    ended: "Ended",
    every: "Every",
    quarters: "quarters",
    anchorDay: "Day of month",
    issueOffsetDays: "Issue offset (days)",
    autoValidate: "Auto validate",
    autoSend: "Auto send",
    autoBilling: "Automatic billing (validate and send)",
    autoBillingRequiresAccount: "The selected service has no accounting account configured; automatic billing requires an account.",
    autoRenew: "Auto renew",
    autoRenewHint: "Automatically renew the contract when it reaches its end date",
    renewDaysBefore: "Renew days before end",
    renewDaysBeforeHint: "Number of days before end date to trigger automatic renewal",
    renewNow: "Renew now",
    renewConfirm: "The contract will be extended by one additional period.",
    contractRenewed: "Contract renewed",
    lifecycleHistory: "Lifecycle history",
    eventRenewed: "Renewed",
    eventEnded: "Ended",
    triggerAuto: "Automatic",
    triggerManual: "Manual",
    noLifecycleEvents: "No lifecycle events",
    renewalCount: "Renewals",
    paymentTermsDays: "Payment terms (days)",

    // Bank statement extraction retry
    retryExtraction: "Retry extraction",
    extractionFailedRetry: "Extraction failed. You can retry.",
    extractionEmptyRetry: "Extraction completed but no lines were found. You can retry.",
    extractionInProgress: "Extraction in progress…",
    retrying: "Retrying…",

    // Dunning policies
    dunningPolicies: "Dunning policies",
    dunningLabelRequired: "Policy name is required",
    dunningStepsRequired: "At least one step is required",
    editDunningPolicy: "Edit dunning policy",
    addDunningPolicy: "Add dunning policy",
    appliesTo: "Applies to",
    both: "Both",
    setAsDefault: "Default policy",
    stopAfterLastStep: "Stop after last step",
    dunningSteps: "Dunning steps",
    addStep: "Add a step",
    step: "Step",
    offsetDays: "Offset (days from due date)",
    offsetDaysHint: "Negative = before due date (courtesy reminder)",
    channel: "Channel",
    escalationTone: "Tone",
    templateKey: "Template key",
    toneNeutral: "Neutral",
    toneFirm: "Firm",
    toneFormal: "Formal",
    addLateFee: "Add late fees",
    lateFeeType: "Fee type",
    lateFeeFixed: "Fixed fee",
    lateFeeInterest: "Late interest",
    lateFeeBoth: "Fixed + interest",
    lateFeeLabel: "Label on invoice",
    fixedAmount: "Fixed amount",
    annualRate: "Annual rate (%)",
    interestBase: "Calculation base",
    basePrincipal: "Principal amount",
    baseCurrent: "Current amount",
    dunningPolicy: "Dunning policy",
    noDunning: "No dunning",
    dunningPolicyHint: "Select the dunning policy to apply to this document",
    dunningConfigured: "Configured",
    dunningRelances: "Dunning",
    dunningActive: "Active",
    dunningSuspended: "Suspended",
    dunningStopped: "Stopped",
    dunningUntil: "until",
    lateFee: "Fees",
    noDunningSent: "No dunning sent yet.",
    suspendDunning: "Suspend dunning?",
    resumeDunning: "Resume",
    stopDunning: "Stop dunning permanently?",
    yesStop: "Yes, stop",
    dunningWillPause: "Automatic dunning will be paused for this invoice.",
    dunningStopIrreversible: "This invoice will never be automatically dunned again.",
    dunningResumed: "Dunning resumed",

    // Subscription banner
    subscriptionTrialBanner: "Your free trial ends on {date} ({days} days remaining)",
    subscriptionPastDueBanner: "Your invoice is unpaid. Please settle before {date} to avoid service interruption",
    subscriptionExpiredBanner: "Your subscription has expired. Access is read-only. Please renew to restore full access",
    subscriptionCancelledBanner: "Your subscription ends on {date}",
    subscriptionDaysRemaining: "{days} days remaining",
    subscriptionPayNow: "Pay now",
    subscriptionChoosePlan: "Choose a plan",

    // Subscription & plan labels
    subscription: "Subscription",
    featureNotIncluded: "Not included in your current plan",
    featureRequiresPlan: "Available from the {plan} plan",
    featureRequiresActiveSubscription: "An active subscription is required",
    featureViewOffers: "View plans",
    featureRegularize: "Renew subscription",
    featureContactAdmin: "Contact your administrator to upgrade",

    // Subscription management (F2)
    subscriptionMySubscription: "My subscription",
    subscriptionOffers: "Plans & pricing",
    subscriptionCurrentPlan: "Current plan",
    subscriptionFreePlan: "Free",
    subscriptionBillingCycle: "Billing cycle",
    subscriptionNextRenewal: "Next renewal",
    subscriptionTrialEndsOn: "Trial ends on {date}",
    subscriptionTrialDaysLeft: "{days} days left in your trial",
    subscriptionPendingChange: "Pending change",
    subscriptionPendingChangeDetail: "You will switch to {plan} on {date}",
    subscriptionCancelPendingChange: "Cancel this change",
    subscriptionPendingChangeCancelled: "Pending change cancelled",
    subscriptionCancelPendingConfirmTitle: "Cancel plan change?",
    subscriptionCancelPendingConfirmText: "Your subscription will remain on the {currentPlan} plan. The switch to {pendingPlan} will not take place.",
    subscriptionQuotas: "Usage & quotas",
    subscriptionQuotaUsage: "{current} / {limit}",
    subscriptionUnlimited: "Unlimited",
    subscriptionChangePlan: "Change plan",
    subscriptionChooseMyOffer: "Choose my plan",
    subscriptionPayMyInvoice: "Pay my invoice",
    subscriptionAnnualSavingsHint: "Save {percent}% with annual billing",
    subscriptionCancelSubscription: "Cancel subscription",
    subscriptionReactivate: "Reactivate",
    subscriptionCancelConfirmTitle: "Cancel your subscription?",
    subscriptionCancelConfirmText: "You will keep access until the end of the current period. After that, your subscription will not renew.",
    subscriptionCancelledSuccess: "Your subscription has been cancelled",
    subscriptionReactivatedSuccess: "Your subscription has been reactivated",
    subscriptionUpgrade: "Upgrade",
    subscriptionDowngrade: "Downgrade",
    subscriptionUpgradeConfirmTitle: "Upgrade to {plan}?",
    subscriptionUpgradeConfirmText: "This change takes effect immediately. You will be charged the prorated difference.",
    subscriptionDowngradeConfirmTitle: "Downgrade to {plan}?",
    subscriptionDowngradeConfirmText: "Your plan will change to {plan} on {date}. You keep all current features until then.",
    subscriptionChangeSuccess: "Your plan has been updated",
    subscriptionEffectImmediate: "Effective immediately",
    subscriptionEffectAtDate: "Effective on {date}",
    subscriptionYouWillBeCharged: "Amount to be charged: {amount}",
    subscriptionProrataNotice: "You will be charged at the prorated rate",
    subscriptionCompareOffers: "Compare plans",
    subscriptionYourCurrentPlan: "Your plan",
    subscriptionSelectPlan: "Select",
    subscriptionIncluded: "Included",
    subscriptionOptionalAddon: "Optional",
    subscriptionNotIncluded: "Not included",
    subscriptionCatalogUnavailable: "Plans are temporarily unavailable. Please try again later.",
    subscriptionNoPricingForCycle: "Not available for this billing cycle",
    subscriptionNoPlan: "No active plan",
    subscriptionStatusActive: "Active",
    subscriptionStatusTrial: "Trial",
    subscriptionStatusPastDue: "Past due",
    subscriptionStatusExpired: "Expired",
    subscriptionStatusCancelled: "Cancelled",
    subscriptionPerMonth: "/month",
    subscriptionPerYear: "/year",
    subscriptionEquivPerMonth: "/mo",
    subscriptionBilledPerYear: "Billed {amount}/year",
    subscriptionSavingsPercent: "Save {percent}%",
    featureComingSoon: "Coming soon",

    // Upgrade modal (F6)
    subscriptionUpgradePlan: "Upgrade a Plan",
    subscriptionWhatsInPlan: "What's in {plan}?",
    subscriptionRecommended: "Recommended",
    subscriptionFeatureRequiresUpgrade: "The {feature} feature requires a plan upgrade.",
    payrollAccessDeniedPlanRequired: "Payroll is not included in your current plan. Upgrade to access this feature.",
    subscriptionModalTitleChoose: "Choose your plan",
    subscriptionModalTitleChange: "Change plan",
    subscriptionSubscribeAction: "Subscribe",
    subscriptionSwitchTo: "Switch to {plan}",
    subscriptionDowngradeTo: "Downgrade to {plan}",
    subscriptionFeaturesAdded: "Features included",
    subscriptionFeaturesRemoved: "Features not included",
    subscriptionSeeAllFeatures: "See all features",
    subscriptionHideFeatures: "Hide features",

    // First-choice flow (Lot 4)
    subscriptionChooseTitle: "Choose your plan",
    subscriptionChooseSubtitle: "Select a plan and optional add-ons to get started.",
    subscriptionChooseConfirmTitle: "Confirm your choice",
    subscriptionChooseConfirmText: "You are about to subscribe to the {plan} plan ({cycle}).",
    subscriptionChooseSuccess: "Your plan has been activated",
    subscriptionChooseWithAddons: "with {count} add-on(s)",
    subscriptionPriceSummary: "Price summary",
    subscriptionPlanPrice: "Plan ({plan})",
    subscriptionAddonsTotal: "Add-ons",
    subscriptionSubtotalHT: "Subtotal excl. VAT",
    subscriptionVatRate: "VAT ({rate}%)",
    subscriptionTotalTTC: "Total incl. VAT",
    subscriptionVatOnInvoiceNote: "All prices are shown excl. VAT. VAT will appear on your invoice.",
    subscriptionConfirmChoice: "Confirm & subscribe",
    subscriptionWizardStepPlan: "Plan",
    subscriptionWizardStepAddons: "Add-ons",
    subscriptionWizardStepSummary: "Summary",
    subscriptionWizardNext: "Next",
    subscriptionWizardBack: "Back",
    subscriptionWizardConfirmAndPay: "Confirm and pay",
    subscriptionAddonsLoading: "Loading available add-ons…",
    subscriptionAddonsLoadError: "Could not load add-ons. Please try again.",
    subscriptionAddonsIncompatibleRemoved: "Some add-ons were removed because they are not compatible with the selected plan.",
    subscriptionTotalHT: "Total excl. VAT",
    subscriptionChangeTitle: "Change your plan",
    subscriptionChangeSubtitle: "Select a new plan and optional add-ons.",
    subscriptionWizardConfirmChange: "Confirm the change",
    subscriptionConfirmedWaiting: "Your subscription is confirmed. We are preparing your invoice\u2026",
    subscriptionInvoiceReady: "Your invoice is ready.",
    subscriptionTimeoutMessage: "Your subscription is confirmed. Your invoice will be available shortly on the subscription screen.",
    subscriptionDownloadingPdf: "Downloading\u2026",
    subscriptionPlanDenied: "This plan is not available for your account.",
    subscriptionAddonBlocksChange: "Some selected add-ons are incompatible with this plan. Please deselect them first.",
    subscriptionSelectAddons: "Optional add-ons",
    subscriptionNoAddonsSelected: "No add-ons selected",
    subscriptionInvoiceNotice: "An invoice will be sent to you {days} days before the start of the subscription.",
    subscriptionTrialUnchanged: "Your free trial remains active until {date}.",
    subscriptionPaymentFlexible: "Each invoice can be paid by QR-bill or credit card — you choose at each due date.",
    subscriptionTermsLink: "General terms and conditions",
    subscriptionRenewalNoticeMonthly: "Your subscription will automatically renew each month at {amount} excl. VAT, unless cancelled beforehand.",
    subscriptionRenewalNoticeYearly: "Your subscription will automatically renew each year at {amount} excl. VAT, unless cancelled beforehand.",
    subscriptionCancellationNotice: "You can cancel your subscription at any time from this page. Cancellation takes effect at the end of the current period — you retain access until that date.",

    // Trial-aware billing disclosures (Lot 3)
    subscriptionInvoiceIssuedNow: "Your invoice is issued immediately, due before {date}.",
    subscriptionTrialUpgradeNotice: "New plan effective immediately. Invoice for the difference of {amount} excl. VAT, due before {date}.",
    subscriptionTrialUpgradeOperatorNotice: "Your first invoice will be issued at the {plan} rate.",
    subscriptionTrialDowngradeNotice: "{plan} will take effect from {date}. Your first period remains on {currentPlan}.",
    subscriptionCancelResiliation: "Cancel cancellation",
    subscriptionCancelResiliationConfirmText: "Your subscription will continue and billing will resume.",
    subscriptionErrorNothingToUndo: "There is no pending cancellation to undo.",
    subscriptionErrorPlanChoiceRequired: "Please choose a plan first before making changes.",

    // Add-ons (F7 part C)
    addonSectionTitle: "Add-ons",
    addonAvailable: "Available",
    addonActive: "Active",
    addonPendingCancellation: "Active — cancels at end of period",
    addonActivate: "Activate",
    addonDeactivate: "Deactivate",
    addonActivateConfirmTitle: "Activate {name}?",
    addonActivateConfirmText: "This add-on costs {price} and billing is immediate. A prorated invoice will be generated right away. This is not a free trial.",
    addonActivateConfirmTextTrial: "This add-on is free until the end of your trial on {date}. No invoice will be issued now. After the trial, it will be billed at {price} along with your plan.",
    addonActivateConfirmButton: "Activate now",
    addonActivatedSuccess: "{name} is now active",
    addonActivatedInvoiceNotice: "The feature is available immediately. A prorated invoice will follow shortly.",
    addonActivatedInvoiceNoticeTrial: "The feature is available immediately, free of charge until {date}. Billing will start with your plan.",
    addonDeactivateConfirmTitle: "Deactivate {name}?",
    addonDeactivateConfirmText: "The add-on will remain active until the end of the current billing period ({date}). No refund will be issued — billing stops at period end.",
    addonDeactivateConfirmButton: "Deactivate at end of period",
    addonDeactivatedSuccess: "{name} will be deactivated at the end of the current period",
    addonAlreadyActive: "This add-on is already active",
    addonIncompatible: "This add-on is not compatible with your current plan",
    addonNoPermission: "You do not have permission to manage add-ons. Contact your administrator.",
    addonActiveUntil: "Active until {date}",
    addonBillingCycleMonthly: "per month",
    addonBillingCycleYearly: "per year",
    addonBillingCycleOneTime: "one-time",
    addonNoneAvailable: "No add-ons available for your current plan.",
    addonManageAddons: "Manage add-ons",

    // Gated nav items — disabled tab tooltips
    navFeatureRequiresUpgrade: "Included from a higher plan",
    navFeatureAvailableAsAddon: "Available as an option",

    // Billing — invoices & payments (F3)
    billingInvoices: "Invoices",
    billingInvoiceNumber: "Number",
    billingInvoiceDate: "Date",
    billingInvoiceDueDate: "Due date",
    billingInvoiceAmount: "Amount",
    billingInvoiceStatus: "Status",
    billingInvoiceStatusOpen: "Open",
    billingInvoiceStatusPaid: "Paid",
    billingInvoiceStatusVoid: "Void",
    billingInvoiceStatusDraft: "Draft",
    billingInvoiceStatusUncollectible: "Uncollectible",
    billingInvoiceOverdue: "Overdue",
    billingPay: "Pay",
    billingDownloadPdf: "Download PDF",
    billingPaymentPending: "Payment in progress…",
    billingPayments: "Payments",
    billingPaymentDate: "Date",
    billingPaymentAmount: "Amount",
    billingPaymentMethod: "Method",
    billingPaymentResult: "Result",
    billingPaymentSucceeded: "Succeeded",
    billingPaymentFailed: "Failed",
    billingPaymentRefunded: "Refunded",
    billingPaymentFailureReason: "Reason",
    billingPaymentRetry: "Retry",
    billingPaymentMethods: "Payment methods",
    billingCardBrand: "Card",
    billingCardEnding: "ending in {last4}",
    billingCardExpires: "Expires {month}/{year}",
    billingCardExpiringSoon: "Expiring soon",
    billingCardDefault: "Default",
    billingAddPaymentMethod: "Add payment method",
    billingDeletePaymentMethod: "Remove",
    billingDeleteMethodConfirmTitle: "Remove this payment method?",
    billingDeleteMethodConfirmText: "This payment method will be permanently removed.",
    billingDeleteDefaultMethodWarning: "This is your default payment method and automatic collection is enabled. Removing it without adding another will cause the next charge to fail.",
    billingMethodDeleted: "Payment method removed",
    billingNoInvoices: "No invoices yet",
    billingNoPayments: "No payments yet",
    billingNoPaymentMethods: "No payment methods registered",
    billingUnavailable: "Billing information is temporarily unavailable. Please try again later.",
    billingInvoiceDetail: "Invoice detail",
    billingRelatedInvoice: "Invoice",
    paymentTitle: "Payment",
    paymentCompany: "Company",
    paymentInvoiceNumber: "Invoice",
    paymentAmount: "Amount",
    paymentDueDate: "Due date",
    paymentExpiry: "Valid until",
    paymentPayNow: "Pay now",
    paymentRedirecting: "Redirecting to payment provider...",
    paymentLinkInvalid: "This payment link is no longer valid.",
    paymentLinkInvalidHint: "Please contact us if you believe this is an error.",
    paymentLinkExpiredTitle: "This payment link has expired",
    paymentLinkExpiredDescription: "This link is no longer valid. Please return to your invoices to request a new payment link.",
    paymentLinkExpiredAction: "Go to my invoices",
    paymentProcessing: "Processing your payment...",
    paymentProcessingHint: "Please wait while we confirm your payment.",
    paymentSucceeded: "Payment successful",
    paymentSucceededHint: "Your payment has been processed. You can close this page.",
    paymentPending: "Payment being processed",
    paymentPendingHint: "Your payment is being processed. You will receive a confirmation by email shortly.",
    paymentFailed: "Payment failed",
    paymentFailedHint: "Your payment could not be processed. Please try again or contact us.",
    paymentCancelled: "Payment cancelled",
    paymentCancelledHint: "You have cancelled the payment. No amount has been charged.",
    paymentStatusUnavailable: "Status unavailable",
    paymentStatusUnavailableHint: "We could not retrieve the payment status. Please check your email for confirmation.",
    paymentRetry: "Retry payment",
    paymentRetryExpired: "This payment link has expired. Please request a new one from your invoices.",
    paymentBackToSubscription: "Back to my subscription",
    paymentRedirectingIn: "Redirecting in {0} s\u2026",
    paymentAmountPaid: "Amount paid",
    paymentSignIn: "Sign in",
    paymentCheckAgain: "Check again",
    paymentNothingElseRequired: "Your invoice has been paid. Nothing else is required.",
    billingAmountDue: "Amount due",
    billingAmountDueCount: "{count} invoices",
    billingDueDate: "Due {date}",
    billingViewInvoices: "View invoices",
    billingPayAmount: "Pay {amount}",
    addonStepTitle: "Add options to your plan",
    addonStepHint: "These options are compatible with your new plan. You can also add them later.",
    addonStepSkip: "Skip",
    addonStepDone: "Continue",
    copy: "Copy",
    copied: "Copied",
    showQrCode: "Show QR code",
    scanToAddMeAsContact: "Scan this code from the mobile app to add me as a contact",
    myDigitalAdminCode: "My Digital Admin code",
    uuidTypeMismatch: "The UUID type does not match the contact type (person/company)",
    uuidNotLinked: "The contact was created, but the UUID provided does not correspond to a registered user",
    chatNoRegisteredContacts: "No registered contacts",
    chatRegisteredContactsHint: "Your contacts who have a Digital Admin account appear here",
    chatMembersUnavailable: "This company does not expose its members",
    chatSelectContact: "Select a contact",
    chatStartNewConversation: "Start a conversation",
    manualEntryMatchesWarning: "Documents or payments match this bank line. Prefer reconciliation from the matches list.",
    viewMatches: "View matches",
    directChargeWarning: "You are recording a direct expense. If this movement pays an existing supplier invoice, use reconciliation to avoid counting the expense twice.",
    directRevenueWarning: "You are recording direct revenue. If this movement collects an existing client invoice, use reconciliation to avoid counting the revenue twice.",

    // Assets (rental inventory)
    assets: "Assets",
    asset: "Asset",
    createAsset: "Create asset",
    editAsset: "Edit asset",
    listAssets: "Asset list",
    viewAsset: "View asset",
    assetName: "Asset name",
    assetCode: "Code",
    assetDescription: "Description",
    defaultDepositAmount: "Default deposit amount",
    acquisitionValue: "Acquisition value",
    acquisitionDate: "Acquisition date",
    isDepreciable: "Depreciable",
    residualValue: "Residual value",
    depreciationYears: "Depreciation period (years)",
    depreciationSection: "Depreciation",
    assetStatusAvailable: "Available",
    assetStatusRented: "Rented",
    assetStatusOutOfService: "Out of service",
    currentTenant: "Current tenant",
    rentedSince: "Rented since",
    rentedUntil: "Rented until",
    searchAsset: "Search asset",
    youWantToDeleteTheAsset: "Do you want to delete this asset?",
    assetDeletedSuccess: "Asset deleted",
    assetCreatedSuccess: "Asset created",
    assetUpdatedSuccess: "Asset updated",
    assetStatusManagedByRental: "The status is managed by rental events",
    noAssetsFound: "No assets found",
    rentAsset: "Rent",
    rentThisAsset: "Rent this asset",
    tenant: "Tenant",
    rentalCadence: "Billing frequency",
    rentalStart: "Start date",
    rentalEnd: "End date",
    rentalDepositAmount: "Security deposit",
    confirmRental: "Confirm rental",
    rentalCreatedSuccess: "Rental contract created",
    cadenceMonthly: "Monthly",
    cadenceQuarterly: "Quarterly",
    cadenceAnnual: "Annual",
    cadenceDay: "Day",
    cadenceWeek: "Week",
    cadenceMonth: "Month",
    cadenceQuarter: "Quarter",
    cadenceYear: "Year",
    rentalOptions: "Rental options",
    addRentalOption: "Add a rental option",
    selectService: "Select a service",
    rentalOption: "Rental option",
    selectRentalOption: "Select a rental option",
    noRentalOptionConfigured: "This asset has no rental options configured.",
    noRentalOption: "No rental option",

    // Security deposit (caution)
    securityDeposit: "Security deposit",
    depositAmount: "Deposit amount",
    depositStatus: "Deposit status",
    depositNone: "None",
    depositPending: "Pending",
    depositReceived: "Received",
    depositPartiallyRetained: "Partially retained",
    depositReturned: "Returned",
    receiveDeposit: "Record receipt",
    returnDeposit: "Return deposit",
    retainedAmount: "Retained amount",
    returnedAmount: "Returned amount",
    retainedAmountHint: "Amount retained for damages",
    amountToReturn: "Amount to return",
    depositReceivedSuccess: "Deposit receipt recorded",
    depositReturnedSuccess: "Deposit returned",
    receivedAt: "Received on",
    returnedAt: "Returned on",
    depositMethod: "Payment method",
    depositNote: "Note",

    // Expense reports
    expenseReports: "Expense Reports",
    expenseReport: "Expense Report",
    expenseReportNumber: "Report No.",
    listExpenseReports: "List Expense Reports",
    createExpenseReport: "Create Expense Report",
    editExpenseReport: "Edit Expense Report",
    viewExpenseReport: "View Expense Report",
    updateExpenseReport: "Update Expense Report",
    submitted: "Submitted",
    validated: "Validated",
    submitExpenseReport: "Submit",
    rejectExpenseReport: "Return for correction",
    validateExpenseReport: "Validate expense report",
    rejectionReason: "Rejection reason",
    rejectionReasonPlaceholder: "Enter the reason for rejection...",
    rejectionReasonRequired: "A rejection reason is required",
    rejectedReason: "Rejection reason",
    reimburse: "Reimburse",
    createReimbursement: "Create Reimbursement",
    createNewReimbursementForExpenseReport: "Create New Reimbursement for Expense Report",
    employee: "Employee",
    merchant: "Merchant",
    expenseDate: "Expense Date",
    youWantToDeleteThisExpenseReport: "Do you want to delete this expense report?",
    processOfCreatingANewExpenseReportCompleted: "Process of creating a new expense report completed.",
    ifYouWantToSaveTheNewExpenseReport: "if you want to save the new expense report.",
    processOfUpdatingAnExpenseReportCompleted: "Process of updating an expense report completed.",
    thisExpenseReportHasNoPayments: "This expense report has no reimbursements.",
    youWantToSubmitThisExpenseReport: "Do you want to submit this expense report?",
    expenseReportSubmittedSuccessfully: "Expense report submitted successfully.",
    youWantToValidateThisExpenseReport: "Do you want to validate this expense report?",
    youWantToInvalidateThisExpenseReport: "If you invalidate this expense report, the associated accounting entries will be deleted.",
    iban: "IBAN",
    receipt: "Receipt",
    attachReceipt: "Attach receipt",
    removeReceipt: "Remove receipt",
    expenseLineDetails: "Expense line details",
    newExpenseReport: "New expense report",
    descriptionCreateExpenseReport: "Please enter the following details, they are required to create a new expense report.",
    pleaseModifyFieldsFromExpenseReport: "Modify, add, and/or delete the fields you want from the expense report.",
    selectAnEmployee: "Select an employee",
    beforeCreatingExpenseReport: "Before creating the expense report",
    wouldYouLikeUploadPdfFilesToExpenseReport: "Would you like to upload PDF files for the new expense report?",
    whenYouUploadPdfFilesTheyArePlacedAsExpenseReportLines: "When you upload PDF files, they are placed as receipt attachments on each expense line of the creation form.",
    expenseBelongsToExpenseReport: "This expense belongs to expense report",
    expenseManagedFromReport: "It can be edited and validated from the expense report.",

    // Write-off
    chargedOff: "Charged off",
    writeOff: "Write off",
    writeOffInvoice: "Write off invoice",
    writeOffAmount: "Write-off amount",
    writeOffDate: "Write-off date",
    writeOffLossAccount: "Loss account",
    writeOffReason: "Reason",
    writeOffReasonRequired: "A reason is required",
    writeOffConfirmMessage: "This invoice will be written off for a loss of",
    writeOffVatCorrectionMessage: "The VAT of {amount} will be corrected (figure 235).",
    writeOffSuccess: "Invoice successfully written off",
    writeOffCancelConfirm: "Do you want to cancel this write-off?",
    writeOffCancelSuccess: "Write-off successfully cancelled",
    writeOffs: "Write-offs",
    writeOffAmountExceedsDebt: "The write-off amount exceeds the remaining debt",
    invoiceAlreadyChargedOff: "This invoice is already charged off",

    // Expense access (employee)
    expenseAccess: "Expense report access",
    expenseAccessAuto: "Automatic (based on status)",
    expenseAccessForcedOn: "Always allowed",
    expenseAccessForcedOff: "Never allowed",
    expenseAccessHelp: "Automatic: allowed if the employee is currently employed (draft or active). Always/Never: forces access regardless of status.",
  },
};
